import type { Translations } from './types';

const fr: Translations = {
  nav: {
    approvals: 'Validations',
    home: 'Accueil',
    search: 'Rechercher',
    dashboard: 'Tableau de bord',
    outdoors: 'Panneaux',
    campaigns: 'Campagnes',
    admin: 'Admin',
    logIn: 'Connexion',
    signUp: "S'inscrire",
    logOut: 'Se déconnecter',
    account: 'Compte',
    setupBusiness: "Configurer l'entreprise",
    searchOutdoors: 'Rechercher des panneaux',
    manageOutdoors: 'Gérer les panneaux',
    verifyOutdoors: 'Vérifier les panneaux',
    adminPanel: "Panneau d'administration",
    upcomingCampaigns: 'Campagnes à Venir',
    getPaid: 'Être Payé',
    revenue: 'Revenus',
    payments: 'Paiements',
  },
  common: {
    save: 'Enregistrer',
    cancel: 'Annuler',
    back: 'Retour',
    next: 'Suivant',
    done: 'Terminé',
    loading: 'Chargement…',
    error: "Une erreur s'est produite",
    confirm: 'Confirmer',
    delete: 'Supprimer',
    clear: 'Effacer',
    edit: 'Modifier',
    add: 'Ajouter',
    search: 'Rechercher',
    view: 'Voir',
    create: 'Créer',
    update: 'Mettre à jour',
    submit: 'Envoyer',
    yes: 'Oui',
    no: 'Non',
    close: 'Fermer',
    upload: 'Téléverser',
    uploading: 'Téléversement…',
    saving: 'Enregistrement…',
    creating: 'Création…',
    noResults: 'Aucun résultat',
    required: 'Obligatoire',
    optional: 'Optionnel',
    copy: 'Copier',
    copied: 'Copié !',
    approve: 'Approuver',
    reject: 'Rejeter',
    page: 'Page',
    of: 'sur',
    perDay: '/jour',
    days: '{{count}} jour',
    days_plural: '{{count}} jours',
    termsAndConditions: 'Conditions Générales',
    selectCountry: 'Sélectionner un pays...',
    noCountriesFound: 'Aucun pays trouvé',
    notSet: 'Non défini',
    showPassword: 'Afficher le mot de passe',
    hidePassword: 'Masquer le mot de passe',
    refresh: 'Actualiser',
    new: 'Nouveau',
    rowsPerPage: 'Lignes par page',
  },
  home: {
    tagline: 'Votre marketplace OOH axé sur la visibilité',
    heroTitle: 'Votre marque vers de nouveaux sommets',
    heroSubtitle:
      "Scapow connecte les propriétaires de panneaux avec les annonceurs. Explorez des espaces réels, planifiez des campagnes et atteignez votre audience - le tout en un seul endroit.",
    browseOutdoors: 'Explorer les panneaux',
    getStartedFree: 'Commencer gratuitement',
    featuredOutdoors: 'Panneaux en vedette',
    viewAll: 'Voir tout →',
    howItWorksTitle: 'Comment ça marche',
    howItWorksSubtitle: 'Trois étapes simples pour diffuser votre message au bon public.',
    step1Title: "Trouver l'espace idéal",
    step1Desc:
      'Recherchez des panneaux par localisation, taille et prix. Filtrez par disponibilité pour vos dates de campagne.',
    step2Title: 'Créer votre campagne',
    step2Desc:
      'Ajoutez plusieurs panneaux à une campagne, téléversez vos créatifs et obtenez les détails de paiement.',
    step3Title: 'Suivre vos résultats',
    step3Desc:
      "Surveillez l'avancement de la campagne, le statut des bannières et les indicateurs de performance depuis votre tableau de bord.",
    builtTitle: 'Conçu pour les deux côtés',
    builtSubtitle:
      'Que vous possédiez des panneaux ou souhaitiez faire de la publicité, Scapow vous couvre.',
    feature1Title: 'Listez vos panneaux',
    feature1Desc:
      'Publiez facilement vos panneaux, définissez les prix, ajoutez des photos et contrôlez la disponibilité.',
    feature2Title: 'Recherche sur la carte',
    feature2Desc:
      'Trouvez des panneaux sur une carte en temps réel. Zoomez pour réduire le rayon, dézoomez pour une plus grande portée.',
    feature3Title: 'Gestion des campagnes',
    feature3Desc:
      'Créez des campagnes avec plusieurs panneaux, téléversez des créatifs et payez par virement bancaire.',
    feature4Title: 'Entreprises vérifiées',
    feature4Desc: 'Toutes les entreprises sont vérifiées avec des documents avant leur mise en ligne.',
    feature5Title: 'Suivi des performances',
    feature5Desc:
      "Les annonceurs et les fournisseurs obtiennent des aperçus du tableau de bord sur les revenus et l'activité.",
    feature6Title: 'Tarifs transparents',
    feature6Desc: 'Tarifs des prestataires affichés par jour - toujours visibles avant de confirmer.',
    ctaTitle: 'Prêt à commencer ?',
    ctaSubtitle: "Rejoignez Scapow aujourd'hui et connectez-vous au marché de la publicité extérieure.",
    createAccount: 'Créer un compte',
    browseFirst: "Explorer d'abord",
    nearbyOutdoors: 'Panneaux Près de Vous',
    detectingLocation: 'Détection de votre position…',
    basedOnLocation: 'Basé sur votre position actuelle',
    welcomeBack: 'Bienvenue, {{name}}',
    fromCompany: 'de {{company}}',
    ppPrompt: 'Tous vos panneaux sont-ils prêts pour de nouvelles Campagnes ?',
    advertiserPrompt: 'Êtes-vous prêt à créer des Campagnes ?',
    noCompanyPrompt: 'Configurez votre entreprise pour débloquer toutes les fonctionnalités.',
    goToDashboard: 'Aller au tableau de bord',
    inviteFrom: '{{company}} vous a invité(e) à rejoindre son équipe sur Scapow.',
    inviteFromDesc: 'Acceptez pour commencer à collaborer sur des campagnes publicitaires extérieures.',
    inviteAccept: "Accepter l'invitation",
    inviteDecline: 'Décliner',
    inviteAccepted: 'Bienvenue ! Vous avez rejoint {{company}} avec succès.',
    inviteDeclined: "Vous avez décliné l'invitation.",
    ppHowItWorksSubtitle: 'Tout ce qu\'il faut pour transformer vos espaces publicitaires en source de revenus régulière.',
    ppStep1Title: 'Mettez vos espaces en valeur',
    ppStep1Desc: 'Listez vos panneaux avec de belles photos, des dimensions précises et des tarifs compétitifs - pour que les annonceurs voient leur valeur au premier coup d\'œil.',
    ppStep2Title: 'Faites-vous découvrir par les marques',
    ppStep2Desc: 'Vos panneaux apparaissent dans les recherches des annonceurs qui planifient leur prochaine campagne. La bonne campagne vous trouve.',
    ppStep3Title: 'Prouvez-le, puis encaissez',
    ppStep3Desc: 'Envoyez des preuves photo une fois votre panneau installé et opérationnel. Le paiement est traité automatiquement après validation.',
  },
  auth: {
    login: {
      heroTitle: 'Connectez votre marque avec le monde. Une nouvelle hauteur à la fois.',
      heroSubtitle:
        'La plateforme qui relie les propriétaires de panneaux aux annonceurs - simple, rapide et percutante.',
      title: 'Bon retour',
      subtitle: 'Connectez-vous à votre compte pour continuer',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      forgotPassword: 'Mot de passe oublié ?',
      resendVerification: "Renvoyer l'e-mail de vérification",
      signIn: 'Se connecter',
      noAccount: "Vous n'avez pas de compte ?",
      createOne: 'En créer un',
      invalidCredentials: 'E-mail ou mot de passe incorrect. Veuillez réessayer.',
    },
    register: {
      heroTitle: 'Rejoignez la révolution de la publicité extérieure',
      heroSubtitle:
        'Que vous possédiez des panneaux ou souhaitiez faire de la publicité, Scapow rend tout simple.',
      title: 'Créer votre compte',
      subtitle: "Commencez à gérer des campagnes d'affichage extérieur dès aujourd'hui",
      firstName: 'Prénom',
      lastName: 'Nom de famille',
      email: 'Adresse e-mail',
      password: 'Mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      passwordHint: 'Minimum 8 caractères',
      createAccount: 'Créer un compte',
      alreadyHaveAccount: 'Vous avez déjà un compte ?',
      signIn: 'Se connecter',
      checkEmail: 'Vérifiez votre e-mail',
      checkEmailDesc:
      'Nous avons envoyé un lien de vérification à votre adresse e-mail. Cliquez dessus pour activer votre compte.',
      goToLogin: 'Aller à la connexion',
      termsAgreement: "J'ai lu et j'accepte les",
      termsLink: 'Conditions Générales',
    },
    forgotPassword: {
      title: 'Réinitialiser votre mot de passe',
      subtitle: 'Entrez votre e-mail et nous vous enverrons un lien de réinitialisation',
      email: 'Adresse e-mail',
      sendReset: 'Envoyer le lien de réinitialisation',
      backToLogin: 'Retour à la connexion',
      checkEmail: 'Vérifiez votre e-mail',
      checkEmailDesc:
        "Si cette adresse est enregistrée, vous recevrez un lien de réinitialisation sous peu.",
    },
    resetPassword: {
      title: 'Définir un nouveau mot de passe',
      subtitle: 'Choisissez un mot de passe solide dont vous vous souviendrez.',
      newPassword: 'Nouveau mot de passe',
      confirmPassword: 'Confirmer le mot de passe',
      save: 'Enregistrer le nouveau mot de passe',
      submit: 'Mettre à jour le mot de passe',
    },
    verifyEmail: {
      verifying: 'Vérification de votre e-mail…',
      success: 'E-mail vérifié !',
      successDesc: 'Votre compte est maintenant actif. Vous pouvez vous connecter.',
      error: 'Échec de la vérification',
      errorDesc: 'Le lien peut être expiré ou invalide. Veuillez vous réinscrire.',
      goToLogin: 'Aller à la connexion',
      successDescBusiness: 'Votre compte est maintenant actif. Vous pouvez vous connecter et configurer votre entreprise.',
      returnToLogin: 'Retour à la connexion',
      resendButton: 'Demander un nouveau lien de vérification',
    },
    resendVerification: {
      title: "Renvoyer l'e-mail de vérification",
      subtitle: "Entrez votre e-mail et nous vous enverrons un nouveau lien de vérification.",
      email: 'Adresse e-mail',
      send: "Envoyer l'e-mail de vérification",
      backToLogin: 'Retour à la connexion',
      checkEmail: 'Vérifiez vos e-mails',
      checkEmailDesc: "Si votre compte est en attente de vérification, nous vous avons envoyé un nouveau lien dans votre boîte de réception.",
    },
  },
  business: {
    pendingVerification: 'Votre compte professionnel est actuellement en cours de validation. Une fois la vérification effectuée par notre équipe, vous aurez un accès complet à toutes les fonctionnalités de Scapow. En attendant, gardez un œil sur votre boîte de réception - nous pourrions vous contacter si des documents supplémentaires s\'avèrent nécessaires.',
    setup: {
      title: "Configurer votre entreprise",
      subtitle: "Liez votre compte à une entité commerciale pour commencer à utiliser Scapow.",
      ppTitle: "Fournisseur d'espaces",
      ppDesc: "Je possède des espaces de publicité extérieure et souhaite les louer.",
      advertiserTitle: 'Annonceur',
      advertiserDesc: "Je souhaite réserver des campagnes de publicité extérieure.",
      changeType: 'Changer ↩',
      createCompany: 'Créer une nouvelle entreprise',
      createCompanyDesc: 'Enregistrez votre entreprise sur Scapow.',
      joinCompany: 'Rejoindre une entreprise existante',
      joinCompanyDesc: "Demandez l'accès à une entreprise déjà enregistrée.",
      registerTitle: "Enregistrer votre entreprise",
      companyName: "Nom de l'entreprise",
      vatNumber: 'Numéro de TVA',
      companyEmail: "E-mail de l'entreprise",
      currency: 'Devise préférée',
      currencyHint: 'Code ISO de devise, ex : EUR, USD, GBP',
      country: 'Pays',
      proofDocument: "Justificatif d'entreprise",
      proofHint: 'PDF, JPG ou PNG',
      uploadProof: "Cliquez pour téléverser le justificatif d'entreprise",
      createCompanyBtn: "Créer l'entreprise",
      bankTitle: 'Coordonnées bancaires',
      bankSubtitlePP: 'Votre IBAN et SWIFT/BIC seront utilisés pour les versements lorsque vos campagnes extérieures seront actives.',
      bankSubtitleAdvertiser: 'Votre IBAN et SWIFT/BIC seront utilisés pour traiter les remboursements le cas échéant.',
      findTitle: 'Trouver votre entreprise',
      searchPlaceholder: "Rechercher par nom d'entreprise…",
      noCompanies: 'Aucune entreprise trouvée. Recherchez par nom.',
      requestAccess: "Demander l'accès",
      requested: 'Demandé',
      accessSentMsg:
        "Demande d'accès envoyée ! Un administrateur de l'entreprise doit l'approuver. Vous serez notifié une fois approuvé.",
      pendingTitle: "Demande d'accès en attente",
      pendingDesc: 'Votre demande pour rejoindre {{name}} est en cours d\'examen. Vous serez notifié une fois approuvé.',
      cancelRequest: 'Annuler la demande',
      requestCancelled: "Demande d'accès annulée.",
      connectingToEntity: 'Connexion à votre organisation…',
      accessApproved: "Votre demande d'accès a été approuvée ! Vous faites maintenant partie de l'équipe.",
      accessRejected: "Votre demande d'accès a été rejetée. Veuillez créer ou rejoindre une autre entité commerciale.",
      orSetupYourOwn: 'Ou enregistrez votre entreprise ou rejoignez-en une existante ci-dessous.',
      invitationsTitle: 'Invitations en attente',
      invitationsSubtitle: "Vous avez été invité à rejoindre une entreprise. Acceptez ou refusez ci-dessous.",
      invitedOn: 'Invité le',
      acceptInvitation: 'Accepter',
      declineInvitation: 'Refuser',
      invitationAccepted: "Invitation acceptée ! Connexion à votre organisation…",
      invitationDeclined: 'Invitation refusée.',
    },
    details: {
      title: "Détails de l'entreprise",
      subtitle: "Gérez l'enregistrement et les informations bancaires de votre entreprise.",
      registrationTitle: "Détails d'enregistrement",
      companyName: "Nom de l'entreprise",
      vatNumber: 'Numéro de TVA',
      companyEmail: "E-mail de l'entreprise",
      currency: 'Devise préférée',
      country: 'Pays',
      portugueseRegion: 'Région portugaise',
      regionContinent: 'Continent',
      regionAzores: 'Açores',
      regionMadeira: 'Madère',
      replaceProof: 'Remplacer le justificatif',
      uploadProof: 'Cliquez pour téléverser un nouveau justificatif',
      saveChanges: 'Enregistrer les modifications',
      addressSectionTitle: 'Adresse',
      addressLine: 'Adresse',
      addressLinePlaceholder: '123 Rue Principale',
      city: 'Ville',
      postCode: 'Code postal',
      state: 'État',
      stateHint: 'Obligatoire pour les comptes de paiement en USD',
      selectState: 'Sélectionnez un état',
      bankTitle: 'Coordonnées bancaires',
      bankSubtitle: 'Utilisé pour recevoir les paiements des annonceurs.',
      bankSubtitlePP: 'Votre IBAN et SWIFT/BIC sont utilisés pour les versements lorsque les campagnes sont actives.',
      bankSubtitleAdvertiser: 'Votre IBAN et SWIFT/BIC sont utilisés pour les remboursements le cas échéant.',
      bankClickUnlock: 'Verrouillé - cliquez pour modifier',
      iban: 'IBAN',
      swift: 'SWIFT / BIC',
      ibanHint: 'Numéro de Compte Bancaire International...',
      swiftHint: '8 ou 11 caractères : code banque (4) + pays (2) + localisation (2) + succursale optionnelle (3)',
      accountNumber: 'Numéro de compte',
      accountNumberHint: 'Votre numéro de compte bancaire américain - USD (4 à 17 chiffres)',
      saveBankDetails: 'Enregistrer les coordonnées bancaires',
      verifiedLocked: "Le nom de l'entreprise, le numéro de TVA et le pays sont verrouillés après vérification.",
      verifiedBadge: 'Vérifié',
      pendingReviewTitle: "En Attente d'Approbation",
      pendingReviewDesc: "Votre inscription professionnelle est en cours d'examen. Vous aurez accès complet à la plateforme dès que notre équipe l'aura approuvée - nous vous notifierons en temps réel.",
      verifiedTitle: 'Identité vérifiée',
      verifiedDesc: "L'identité de votre entreprise a été confirmée. Aucune documentation supplémentaire n'est requise.",
      proofCardTitle: 'Document de vérification',
      proofCardDesc: "Téléversez le document d'immatriculation de votre entreprise pour soutenir la vérification de votre compte. Notre équipe l'examinera et vous contactera si nécessaire.",
      proofCardSubmit: 'Soumettre pour examen',
      proofCardSuccess: 'Document soumis avec succès. Notre équipe le vérifiera et vous contactera si besoin.',
      proofCardValidatingTitle: 'Documents en cours d\'examen',
      proofCardValidatingDesc: 'Vos documents de vérification ont bien été reçus et sont actuellement examinés par notre équipe. Nous vous informerons dès que le processus sera terminé.',
      proofCardProcessingTitle: 'Traitement du fichier',
      proofCardProcessingDesc: 'Nous avons bien reçu votre document et le vérifions automatiquement. Cela ne prendra pas longtemps.',
      proofCardReplaceFile: 'Mauvais fichier envoyé ? Remplacez-le',
    },
  },
  search: {
    instantBookingHint: 'Confirmation immédiate, sans attendre la validation du fournisseur',
    priceFilterLocked: 'Les filtres de prix sont disponibles une fois connecté et rattaché à une entité professionnelle.',
    title: 'Rechercher des panneaux',
    subtitle: 'Trouvez des espaces publicitaires sur la carte',
    filters: 'Filtres',
    minWidth: 'Largeur min (m)',
    maxWidth: 'Largeur max (m)',
    minHeight: 'Hauteur min (m)',
    maxHeight: 'Hauteur max (m)',
    minPrice: 'Prix min (€/jour)',
    maxPrice: 'Prix max (€/jour)',
    providerName: 'Nom du fournisseur',
    clearFilters: 'Effacer les filtres',
    noResults: 'Aucun panneau trouvé dans cette zone',
    noResultsDesc: 'Essayez d\'élargir la zone sur la carte, d\'affiner vos filtres ou d\'allonger la durée de votre campagne pour élargir les disponibilités.',
    addToCart: 'Ajouter au panier',
    inCart: 'Dans le panier',
    selectDates: 'Sélectionner les dates',
    from: 'Du',
    to: 'Au',
    results: 'résultats',
    loading: 'Chargement des panneaux…',
    resultsTab: 'Résultats ({{count}})',
    mapTab: 'Carte',
    searching: 'Recherche en cours…',
    found: '{{count}} panneau trouvé',
    found_plural: '{{count}} panneaux trouvés',
    moveMap: 'Déplacez la carte pour mettre à jour les résultats',
    noticePeriodHint: "Certains fournisseurs d'espaces exigent un délai de préavis minimum avant le début d'une campagne, ou une durée minimale de location, ce qui peut affecter la disponibilité et les résultats de recherche.",
    noOutdoorsFound: 'Aucun espace publicitaire trouvé',
    noOutdoorsFoundAdjustDates: "Essayez d'ajuster vos dates de début et de fin, ou dézoomez.",
    noOutdoorsFoundAdjustFilters: 'Dézoomez ou ajustez vos filtres.',
    inCampaign: 'En campagne',
    attributes: 'Situé près de',
    withDiscounts: 'Remises sur volume disponibles',
    illuminated: 'Éclairés uniquement',
    illuminatedHint: 'le panneau est éclairé (ex : la nuit)',
    containsDiscounts: 'Remises sur volume',
    containsDiscountsDesc: 'Cet espace propose une tarification dégressive - plus vous réservez de jours, plus le tarif journalier est bas.',
  },
  outdoor: {
    startAtMonthFirstDay: 'Commencer le 1er du mois',
    startAtMonthFirstDayHint: 'Les réservations doivent commencer le 1er jour d’un mois. Avec les mois complets uniquement, elles se font par mois calendaires complets (du 1er au dernier jour).',
    acceptingToastOn: '{{name}} accepte désormais de nouvelles campagnes.',
    acceptingToastOff: '{{name}} est en pause - masqué de la recherche et fermé aux nouvelles réservations.',
    acceptingToastBulkOn: '{{count}} espace(s) acceptent désormais de nouvelles campagnes.',
    acceptingToastBulkOff: '{{count}} espace(s) en pause - masqués de la recherche et fermés aux nouvelles réservations.',
    fullMonthRequired: 'Mois complets uniquement',
    fullMonthRequiredHint: 'Les annonceurs réservent au mois : de leur jour de début au même jour du mois suivant (en commençant le 1er, jusqu’au dernier jour du mois), pour autant de mois consécutifs qu’ils le souhaitent.',
    fullMonthTooltip: 'Réservé au mois - du jour de début au même jour d’un mois suivant.',
    stepsTitle: 'Configuration de l’espace',
    stepNotSet: 'Pas encore défini',
    stepLocationSet: 'Emplacement placé',
    stepNoticeSummary: 'Préavis : {{count}} jour(s)',
    stepPhotosSummary: 'Photos : {{count}}',
    stepPhotosNone: 'Pas encore de photos',
    stepBlockedSummary: 'Périodes bloquées : {{count}}',
    stepOptional: 'Facultatif',
    stepFeaturesSummary: 'Sélectionnées : {{count}}',
    fixHighlightedFields: 'Certaines informations sont à corriger - nous avons ouvert l’étape concernée.',
    instantBooking: 'Réservation instantanée',
    instantBookingTooltip: 'Réservé immédiatement, sans attendre la confirmation du fournisseur.',
    instantBookingHint: 'Les annonceurs réservent cet espace immédiatement, sans attendre votre validation. Laissez désactivé pour examiner chaque réservation d’abord.',
    kmAway: 'à {{distance}} km',
    productionCost: 'Coût de production',
    productionCostIncludes: 'inclut les frais d’impression, d’installation, etc.',
    priceHiddenTitle: 'Valeurs journalières réservées aux comptes professionnels',
    priceHiddenMessage: 'Connectez-vous et assurez-vous d’être rattaché à une entité professionnelle (fournisseur d’espaces ou annonceur) pour voir la valeur journalière de l’espace.',
    manageTitle: 'Gérer les panneaux',
    addNew: 'Ajouter un nouveau panneau',
    noOutdoors: 'Aucun panneau pour le moment',
    noOutdoorsDesc: 'Ajoutez votre premier panneau pour commencer à recevoir des réservations.',
    addFirst: 'Ajouter votre premier panneau',
    editTitle: 'Modifier le panneau',
    createTitle: 'Ajouter un nouveau panneau',
    listSubtitle: 'Publiez votre panneau sur Scapow.',
    editSubtitle: 'Mettez à jour les détails de votre panneau.',
    location: 'Emplacement',
    latitude: 'Latitude',
    longitude: 'Longitude',
    name: 'Nom',
    namePlaceholder: 'ex : Champs-Élysées – Panneau A',
    description: 'Description',
    descriptionPlaceholder: 'Panneau premium sur les Champs-Élysées, zone très fréquentée…',
    dimensions: 'Dimensions et spécifications',
    width: 'Largeur (m)',
    height: 'Hauteur (m)',
    length: 'Longueur (m)',
    aspectRatio: 'Format du créatif',
    aspectRatioHint: 'Calculé automatiquement à partir de largeur ÷ hauteur',
    bleed: 'Fond perdu (m)',
    bleedHint: 'Zone d\'impression au-delà du bord de rognage final, garantissant des bords nets après découpe.',
    illuminated: 'Éclairé',
    illuminatedHint: 'Cet espace publicitaire est éclairé, le rendant visible la nuit.',
    currency: 'Devise',
    currencyLockedHint: 'Définie par la devise de votre compte Prestataire.',
    pricing: 'Tarification',
    excludeVat: 'hors TVA',
    vatIncluded: 'TVA incluse',
    pricePerDay: 'Prix par jour',
    volumeDiscounts: 'Remises sur volume',
    addDiscount: 'Ajouter',
    daysArrow: 'jours →',
    percentOff: '% de remise',
    photos: "Photos de l'emplacement",
    photosHint: 'Les photos sont enregistrées automatiquement lors de leur ajout ou de leur suppression.',
    uploadPhotos: "Cliquez pour téléverser des photos de l'emplacement",
    addMorePhotos: 'Ajouter des photos',
    currentPhotos: 'Photos actuelles',
    uploadingPhotos: 'Téléversement des photos...',
    photosUploaded: 'Photos téléversées avec succès',
    deletePhotoTitle: 'Supprimer la photo ?',
    deletePhotoConfirm: 'Cette photo sera définitivement supprimée de cet outdoor.',
    filesSelected_one: '{{count}} fichier sélectionné',
    filesSelected_other: '{{count}} fichiers sélectionnés',
    blockedTimes: 'Périodes bloquées',
    blockedTimesDesc:
      "Bloquez les dates où le panneau n'est pas disponible (maintenance, pré-réservations externes, etc.).",
    blockedTimesOverlapNote: "Les plages ne peuvent pas se chevaucher entre elles ni avec des réservations de campagnes actives.",
    blockFrom: 'Bloquer du',
    blockUntil: "Bloquer jusqu'au",
    addBlockedTime: 'Ajouter une période bloquée',
    noBlockedTimes: 'Aucune période bloquée',
    occupiedByCampaign: 'Réservé par une campagne',
    unsaved: 'Non enregistré',
    unsavedChanges: '{{count}} modification(s) non enregistrée(s) - enregistrez l\'outdoor pour appliquer',
    selectBlockedDates: 'Veuillez sélectionner une date de début et une date de fin.',
    legalDeclaration: "Je déclare disposer des droits légaux sur cet espace publicitaire, être autorisé à le commercialiser et que cette mise en ligne respecte l'ensemble des lois, autorisations et réglementations applicables.",
    legalDeclarationRequired: 'Vous devez confirmer vos droits légaux sur cet espace avant de le publier.',
    createOutdoor: 'Créer le panneau',
    saveChanges: 'Enregistrer les modifications',
    deleteTitle: 'Supprimer le panneau',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer ce panneau ? Cette action est irréversible.',
    hidden: 'Masqué',
    visible: 'Visible',
    viewDetails: 'Voir les détails',
    bookingRules: 'Règles de réservation',
    bookingRulesDesc: 'Définissez les délais minimaux que les annonceurs doivent respecter avant la date de début de la campagne.',
    minimumNoticeDays: 'Préavis minimum (jours)',
    minimumNoticeDaysHint: 'Les campagnes doivent être entièrement payées et le visuel téléchargé au moins ce nombre de jours avant la date de début.',
    minimumDays: 'Durée minimale de location (jours)',
    minimumDaysHint: 'Le nombre minimal de jours pendant lesquels les annonceurs doivent louer cet espace.',
    acceptingCampaigns: 'Accepte de nouvelles campagnes',
    acceptingCampaignsOn: 'Cet outdoor est visible dans la recherche et peut être ajouté à des campagnes.',
    acceptingCampaignsOff: "Cet outdoor est masqué de la recherche et ne recevra pas de nouvelles réservations.",
    acceptingBadge: 'Accepte les campagnes',
    notAcceptingBadge: "N'accepte pas les campagnes",
    notAcceptingMsg: "Cet outdoor n'accepte pas de nouvelles campagnes pour le moment.",
    unavailableForDates: 'Cet outdoor est indisponible pour les dates sélectionnées.',
    paused: 'En pause',
    accepting: 'Accepte',
    availabilityToggleTooltip: 'Indique si cet outdoor est disponible pour des campagnes ou non. État actuel : {{state}}',
    availabilityStateOn: 'Disponible',
    availabilityStateOff: 'Indisponible',
    toggleError: 'Échec de la mise à jour de la visibilité de la campagne.',
    bulkAccept: 'Activer la réception de campagnes pour tous les panneaux de cette page',
    bulkPause: 'Suspendre la réception de campagnes pour tous les panneaux de cette page',
    commissionNote: 'Les annonceurs se verront proposer <bold>{{currency}} {{advertiserPrice}}/jour</bold> - votre {{currency}} {{basePrice}} plus une <bold>commission Scapow de {{rate}}%</bold>.',
    advertiserPaysLabel: "L'annonceur paie",
    advertiserPaysDesc: 'Inclut {{rate}}% de commission Scapow',
    youReceiveLabel: '{{name}} perçoit',
    youReceiveDesc: "Après {{rate}}% de frais de plateforme (la TVA sur la commission peut s'appliquer)",
    searchByAddress: 'Rechercher par adresse',
    dragPin: 'Faites glisser le repère pour affiner la position exacte.',
    myOutdoors: 'Mes panneaux',
    myOutdoorsSubtitle: 'Gérez votre inventaire de panneaux',
    viewCalendarTooltip: 'Consultez les dates bloquées pour cet Outdoor',
    calendarModalTitle: 'Calendrier - {{name}}',
    addOutdoor: 'Ajouter un panneau',
    searchByName: 'Rechercher par nom…',
    deleteConfirmNamed: 'Êtes-vous sûr de vouloir supprimer "{{name}}" ? Cette action est irréversible.',
    specifications: 'Spécifications',
    creativeRatio: 'Format du créatif',
    coordinates: 'Coordonnées',
    price: 'Prix',
    plusVat: '+ TVA',
    unavailableDates: 'Dates indisponibles',
    duration: 'Durée',
    addToCampaign: 'Ajouter à la campagne',
    goToCampaign: 'Aller à la campagne',
    signInToAdd: 'Connectez-vous/Inscrivez-vous pour ajouter cet Outdoor à votre Campagne',
    bookingsCalendarTitle: 'Calendrier des réservations',
    bookingsCalendarSubtitle: 'Voyez quand vos campagnes démarrent, sont diffusées et se terminent. Choisissez un jour pour voir les espaces réservés.',
    legend_starting: 'Début de campagne',
    legend_startingDesc: 'Une réservation démarre',
    legend_running: 'Campagne en cours',
    legend_runningDesc: 'Votre espace est diffusé',
    legend_finishing: 'Fin de campagne',
    legend_finishingDesc: 'Dernier jour d’une réservation',
    legend_blocked: 'Dates bloquées',
    legend_blockedDesc: 'Espaces que vous avez rendus indisponibles',
    legend_none: 'Aucune réservation',
    legend_noneDesc: 'Aucun de vos espaces n’est réservé',
    legend_mixed: 'Couleurs partagées : plusieurs états ce jour-là',
    calendarToday: 'Aujourd’hui',
    selectDayHint: 'Choisissez un jour pour voir ses réservations. Cliquez à nouveau pour effacer.',
    clearDateSelection: 'Effacer la date sélectionnée',
    dailyStatesError: 'Impossible de charger les réservations de ce mois. Essayez d’actualiser.',
    searchBookedByName: 'Rechercher les espaces réservés par nom…',
    clearSearch: 'Effacer la recherche',
    bookedOutdoorsCount: 'Espaces réservés : {{count}}',
    noBookingsOnDate: 'Aucun espace réservé ce jour-là',
    noBookedOutdoorsMatch: 'Aucun espace réservé ne correspond à « {{name}} » ce jour-là',
    noBookingsOnDateHint: 'Choisissez un autre jour ou effacez la date pour voir tous vos espaces.',
    bookingPeriod: 'Période de réservation',
    logIn: 'Se connecter',
    register: 'S’inscrire',
    selectCampaignToAdd: 'Veuillez sélectionner une campagne pour ajouter cet espace',
    changeCampaign: 'Modifier',
    alreadyInCampaign: 'Déjà dans la campagne',
    billboardFallback: 'Panneau publicitaire',
    bookMoreThanDays: 'Réservez plus de {{count}} jours',
    percentageOff: '{{percentage}}% de remise',
    comingSoon: 'Vos panneaux arriveront bientôt !',
    attributes: 'Situé près de',
    attributesHint: 'Aidez les annonceurs à vous trouver plus vite. Indiquez ce qui se trouve à proximité pour booster la visibilité de votre panneau dans les résultats de recherche.',
  },
  outdoorDetail: {
    productionCost: 'Coût de production',
    bookingTitle: 'Réserver ce panneau',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    estimatedCost: 'Coût estimé',
    addToCart: 'Ajouter au panier',
    inCart: 'Déjà dans le panier',
    specs: 'Spécifications',
    dimensions: 'Dimensions',
    aspectRatio: 'Format requis',
    pricePerDay: 'Prix par jour',
    location: 'Emplacement',
    blockedTimes: 'Périodes bloquées',
    discounts: 'Remises sur volume',
    noBlockedTimes: 'Aucune période bloquée',
    noDiscounts: 'Aucune remise disponible',
    photos: 'Photos',
    days: 'jours',
    total: 'Total',
    discount: 'remise',
    campaignBookings: 'Réservations de Campagne',
    inCampaign: 'En Campagne',
    minimumNoticeInDays: 'Délai minimum de réservation',
  },
  campaign: {
    methodFlowLabel: 'Comment vous paierez',
    methodFirstPayment: '1er paiement',
    methodCard: 'Carte',
    methodThenMonthly: 'Puis chaque mois',
    methodThenTrimonthly: 'Puis tous les 3 mois',
    methodDirectDebit: 'Prélèvement',
    searchByName: 'Rechercher des campagnes par nom…',
    clearSearch: 'Effacer la recherche',
    resultsSummary: 'Résultats : {{total}} · Page {{page}} sur {{pages}}',
    noSearchResults: 'Aucune campagne ne correspond à « {{name}} »',
    noSearchResultsHint: 'Vérifiez l’orthographe ou essayez un autre nom.',
    eventFeedbackReceived: 'Un fournisseur a répondu au sujet des espaces de votre campagne.',
    eventConfirmationUpdated: 'La confirmation de votre campagne est terminée - consultez son nouveau statut.',
    eventViewCampaign: 'Voir la campagne',
    planTrimonthlyTitle: 'Payer tous les 3 mois',
    planTrimonthlyDesc: 'Payez maintenant les coûts de production et les 3 premiers mois. Chaque trimestre suivant est prélevé le premier jour.',
    visitCampaignPage: 'Voir la page de la campagne',
    payStepNotice: 'La disponibilité des espaces est revérifiée au paiement : en cas de changement, nous vous prévenons avant tout débit.',
    removeOutdoor: 'Retirer cet espace',
    noOutdoorsYetDesc: 'Parcourez la carte pour trouver des espaces pour votre campagne, puis choisissez vos dates.',
    creativesNeedOutdoors: 'Ajoutez d’abord des espaces : les visuels nécessaires dépendent de leurs dimensions.',
    stepAnnounce: 'Étape {{n}} sur {{total}} : {{step}}',
    stepsDone: '{{done}} sur {{total}} terminées',
    stepDone: 'Terminé',
    stepToDo: 'À faire',
    stepPrevious: 'Retour : {{step}}',
    stepNext: 'Suivant : {{step}}',
    stepOutdoorsSummary: 'Espaces : {{count}}',
    stepCreativesSummary: '{{done}} sur {{total}} prêts',
    stepTermsAccepted: 'Acceptées',
    stepTermsPending: 'Pas encore acceptées',
    stepPendingHint_outdoors: 'Ajoutez au moins un espace pour continuer.',
    stepPendingHint_creatives: 'Tous les visuels requis doivent être envoyés et validés.',
    stepPendingHint_terms: 'Acceptez les conditions pour débloquer le paiement.',
    goToPayment: 'Aller au paiement',
    acceptTermsStepLabel: 'J’ai lu et j’accepte les Conditions générales de cette campagne.',
    payStepTitle: 'Vérifier et payer',
    payStepMissingTitle: 'Terminez ces étapes pour payer :',
    payStepTotal: 'Total de la campagne',
    scheduleTitle: 'Échéancier',
    scheduleTotal: 'Total {{amount}}',
    scheduleFullPayment: 'Paiement intégral',
    scheduleFirstPayment: 'Premier paiement · {{month}}',
    scheduleDueAtCheckout: 'Débité au paiement',
    scheduleAuthorisedAtCheckout: 'Autorisé au paiement, débité une fois les fournisseurs ayant confirmé',
    scheduleDueOn: 'Le {{date}}',
    schedulePaidOn: 'Payé le {{date}}',
    scheduleProcessing: 'En cours - un prélèvement prend quelques jours',
    scheduleFailed: 'Échec du paiement',
    scheduleCancelled: 'Annulé - ne sera pas débité',
    scheduleSplit: 'Production {{production}} · Jours de campagne {{ads}}',
    scheduleVatIncluded: 'Tous les montants incluent la TVA.',
    paymentsTitle: 'Paiements',
    paymentsPaidSoFar: 'Payé à ce jour',
    paymentsRemaining: 'Reste à payer : {{amount}}',
    paymentsFailedNotice: 'Un prélèvement n’a pas abouti. Vérifiez votre compte bancaire ou contactez-nous pour que votre campagne ne soit pas interrompue.',
    paymentPlanTitle: 'Comment souhaitez-vous payer ?',
    paymentPlanSubtitle: 'Choisissez avant le paiement. Modifiable jusqu’au paiement.',
    planTotalTitle: 'Payer en une fois',
    planTotalDesc: 'Un seul paiement pour toute la campagne.',
    planMonthlyTitle: 'Payer mensuellement',
    planMonthlyDesc: 'Payez maintenant les coûts de production et le premier mois. Chaque mois suivant est prélevé le 1er.',
    paymentPlanError: 'Impossible de mettre à jour le mode de paiement.',
    checkoutAllInstant: 'Tous les espaces sont en réservation instantanée : vous êtes débité au paiement et votre campagne est confirmée immédiatement.',
    checkoutNeedsConfirmation: '{{count}} espace(s) sur {{total}} nécessitent la confirmation de leur fournisseur. Au paiement, votre carte est seulement autorisée : vous êtes débité une fois les fournisseurs ayant confirmé, et uniquement pour les espaces validés.',
    mandateStepTitle: 'Étape 1 sur 2 · Mettez en place votre prélèvement',
    mandateStepDesc: 'Ensuite, vous effectuerez votre premier paiement par carte.',
    confirmingTitle: 'En attente de la confirmation des fournisseurs',
    confirmingDesc: 'Votre carte a été autorisée, pas débitée. Vous ne serez débité que pour les espaces validés par leurs fournisseurs.',
    awaitingDecisionTitle: 'Certains espaces ne sont pas disponibles',
    awaitingDecisionDesc: 'Continuez avec les espaces validés, ou annulez la campagne et libérez votre paiement.',
    providersAnswerBy: 'Les fournisseurs répondent d’ici le {{date}}',
    decideBy: 'Décidez d’ici le {{date}}, sinon la campagne est annulée et rien n’est débité.',
    feedbackCount_approved: 'Validés : {{count}}',
    feedbackCount_confirming: 'En attente de réponse : {{count}}',
    feedbackCount_unavailable: 'Indisponibles : {{count}}',
    feedbackCount_expired: 'Sans réponse à temps : {{count}}',
    proceedWithApproved: 'Continuer avec les espaces validés',
    proceedNoneApproved: 'Aucun espace n’a encore été validé.',
    removeConfirmingHint: 'Vous pouvez encore retirer les espaces en attente de réponse.',
    proceedModalTitle: 'Continuer avec les espaces validés ?',
    proceedOutdoorsLabel: 'Espaces réservés',
    proceedOutdoorsValue: '{{approved}} sur {{total}}',
    proceedChargedLabel: 'Vous serez débité de',
    proceedTotalMonthlyLabel: 'Total de la campagne',
    proceedModalNote: 'Ce montant est débité maintenant sur votre carte.',
    proceedModalMonthlyNote: 'Votre premier paiement est prélevé maintenant, le reste en plusieurs fois par prélèvement.',
    proceedModalDropped: 'Les autres espaces ({{count}}) seront retirés de cette campagne.',
    proceedSuccess: 'Votre campagne est confirmée.',
    cancelDecisionTitle: 'Annuler cette campagne ?',
    cancelDecisionDesc: 'Le paiement autorisé est libéré et rien n’est débité. Tous les espaces redeviennent disponibles pour d’autres annonceurs.',
    unavailableTitle: 'Aucun des espaces n’était disponible',
    unavailableDesc: 'Leurs fournisseurs n’ont pas pu confirmer ces dates, donc rien n’a été débité. Essayez d’autres dates ou d’autres espaces.',
    feedback_CONFIRMING: 'En attente du fournisseur',
    feedback_APPROVED: 'Validé',
    feedback_UNAVAILABLE: 'Indisponible',
    feedback_EXPIRED: 'Sans réponse',
    creativeThumbnailAlt: 'Visuel de la campagne {{name}}',
    title: 'Campagnes',
    newCampaign: 'Nouvelle campagne',
    newCampaignTooltip: 'Cliquez pour créer une nouvelle campagne',
    mustRegisterAsAdvertiser: "Vous devez vous inscrire en tant qu'Annonceur pour créer des Campagnes",
    noCampaigns: 'Aucune campagne pour le moment',
    noCampaignsDesc: 'Créez votre première campagne pour commencer à faire de la publicité extérieure.',
    browseSpaces: 'Explorer les espaces publicitaires',
    status: 'Statut',
    from: 'Du',
    to: 'Au',
    filter: 'Filtrer',
    clearFilter: 'Effacer le filtre',
    outdoorSlots: 'Espaces outdoor',
    outdoorsColHeader: 'Espaces',
    startDate: 'Date de début',
    endDate: 'Date de fin',
    paginationRange: 'Campagnes {{from}}-{{to}} sur {{total}}',
    creatives: 'Créatifs',
    payment: 'Paiement',
    deleteTitle: 'Supprimer la campagne',
    deleteConfirm: 'Êtes-vous sûr de vouloir supprimer cette campagne ? Cette action est irréversible.',
    uploadCreative: 'Téléverser un créatif',
    removeCreative: 'Supprimer',
    deletingCreative: 'Suppression du créatif…',
    creativeRatioMismatch: 'Le ratio de l\'image ne correspond pas au format {{ratio}} requis. Veuillez télécharger une image avec les proportions correctes ou un PDF.',
    getPaymentDetails: 'Obtenir les détails de paiement',
    requiredRatios: 'Formats de créatifs requis',
    iban: 'IBAN',
    reference: 'Référence de paiement',
    viewCampaign: 'Voir',
    loading: 'Chargement des campagnes…',
    noSlots: "Aucun espace d'affichage dans cette campagne.",
    noCreatives: 'Aucun créatif téléversé pour le moment.',
    subtitle: 'Gérez vos campagnes de publicité extérieure',
    noFound: 'Aucune campagne trouvée',
    noFoundDesc: 'Commencez par ajouter des panneaux à votre panier pour créer votre première campagne.',
    browseOutdoors: 'Explorer les panneaux',
    outdoorsCount: '{{count}} panneau',
    outdoorsCount_plural: '{{count}} panneaux',
    creativesCount: '{{count}} créatifs',
    paymentLabel: 'Paiement : {{status}}',
    backToCampaigns: 'Retour aux campagnes',
    checklistTitle: 'Liste de vérification de la campagne',
    checklistOutdoors: "Choisissez des panneaux pour votre campagne",
    checklistCreatives: 'Ajouter des créatifs',
    checklistTerms: 'Accepter les Conditions Générales',
    checklistPay: 'Payer la campagne',
    acceptTermsPrefix: "J'accepte les",
    acceptTermsLink: 'Conditions Générales',
    acceptTermsRequiredHint: 'Vous devez accepter les Conditions Générales avant de payer cette campagne.',
    advertiserTermsModalTitle: 'Conditions Générales pour Annonceurs et Campagnes',
    advertiserTermsModalHint: 'Voici les sections de nos Conditions Générales qui s\'appliquent spécifiquement aux annonceurs et aux campagnes.',
    viewFullTerms: 'Voir les Conditions Générales complètes',
    outdoorsHeader: 'Panneaux ({{count}})',
    noOutdoorsYet: "Aucun panneau ajouté pour le moment.",
    requiredAspectRatios: 'Formats de créatifs requis',
    recResolution: 'recommandé: {{w}}×{{h}} cm @ {{dpi}} dpi (1:{{scale}})',
    recInclBleed: 'fond perdu inclus',
    dimensionsCalculatorBleedNote: 'Ce support a {{bleed}} cm de fond perdu sur chaque bord : les dimensions couvrent donc toute la zone d\'impression de {{w}} × {{h}} m (la zone visible fait {{trimW}} × {{trimH}} m).',
    orientationLandscape: 'Paysage',
    orientationPortrait: 'Portrait',
    dimensionsCalculatorTooltip: 'Calculer les dimensions possibles du visuel',
    dimensionsCalculatorTitle: 'Calculateur de dimensions pour un visuel au format {{ratio}}',
    dimensionsCalculatorHint: "Modifiez la largeur ou la hauteur (en centimètres) : l'autre côté se met à jour automatiquement pour conserver ce format. Nous travaillons toujours à 300 dpi, en privilégiant une échelle de 1:10 par rapport à la taille réelle du support extérieur.",
    dimensionsCalculatorWidthLabel: 'Largeur (cm)',
    dimensionsCalculatorHeightLabel: 'Hauteur (cm)',
    dimensionsCalculatorDpiLabel: "Résolution d'impression",
    dimensionsCalculatorScaleHint: 'Échelle : 1:{{scale}} - nous recommandons 1:10 ou un visuel plus grand (chiffre d\'échelle plus petit).',
    dimensionsCalculatorExportHint: 'Exportez votre fichier à {{w}} × {{h}} px.',
    dimensionsCalculatorMinQualityWidth: "Trop petit pour une bonne qualité d'impression - au moins {{min}} cm nécessaires pour un visuel à l'échelle 1:{{scale}}.",
    dimensionsCalculatorMinQualityHeight: "Trop petit pour une bonne qualité d'impression - au moins {{min}} cm nécessaires pour un visuel à l'échelle 1:{{scale}}.",
    processingImage: 'Traitement de l\'image...',
    noCreativesYet: 'Aucun créatif téléversé pour le moment',
    creativesNote: 'Ce sont les visuels qui seront diffusés sur les supports d\'affichage extérieur tout au long de votre campagne.',
    clickToUpload: 'Cliquez pour téléverser',
    creativeValid: 'Approuvé',
    creativeUnderReview: 'En révision',
    creativeInvalid: 'Invalide',
    deleteCreativeTitle: 'Supprimer le créatif ?',
    deleteCreativeBody: 'Ce créatif a été approuvé ou est en cours de révision. Sa suppression le retirera de la campagne et nécessitera un nouvel envoi.',
    campaignInfo: 'Infos sur la campagne',
    details: 'Détails',
    requestPayment: 'Demander le paiement',
    paymentDetails: 'Détails du paiement',
    currency: 'Devise',
    bankTransferDetails: 'Coordonnées bancaires pour virement',
    amount: 'Montant',
    importantRef: '⚠️ Important - Référence de paiement',
    refNote: "Vous devez inclure cette référence dans la description de votre virement pour qu'elle soit associée automatiquement.",
    deleteCampaign: 'Supprimer la campagne',
    deleteCampaignDesc: 'Cela supprimera définitivement cette campagne et toutes les données associées. Cette action est irréversible.',
    addOutdoor: 'Ajouter un panneau',
    outdoorAdded: 'Panneau ajouté à la campagne',
    selectOutdoor: 'Sélectionner un panneau',
    outdoorDateConflict: 'Ce panneau est déjà réservé dans cette campagne pour des dates qui se chevauchent. Veuillez choisir des dates différentes.',
    alreadyInCampaign: 'Dans la campagne',
    name: 'Nom',
    outdoorSubtotal: 'Sous-total',
    bankTransferNoticeTitle: 'Paiement de Campagne Requis',
    bankTransferNotice: 'Votre campagne ne sera activée et les emplacements formellement réservés qu\'à réception de la confirmation de paiement. Cliquez sur "Valider et Payer" pour continuer. À noter : la disponibilité des emplacements est revalidée au moment du paiement - des espaces disponibles lors de leur ajout à la campagne peuvent ne plus être garantis.',
    requestPaymentDisabledHint: 'Les {{count}} créatifs requis doivent être téléversés et validés (statut : Valide) avant de pouvoir demander le paiement.',
    outdoorRemoved: 'Panneau retiré de la campagne.',
    removeOutdoorConfirm: 'Êtes-vous sûr de vouloir retirer cet espace de la campagne ? Cette action est irréversible.',
    qualityFail: 'Résolution insuffisante - fichier non téléchargé',
    qualityWarn: 'Format incompatible - l\'image peut être recadrée ou avoir des marges',
    qualityAspectMismatch: 'Format {{actual}} vs {{expected}} (affichage)',
    qualityUploadAnyway: 'Télécharger quand même',
    qualityConfirmHint: 'L\'image peut être recadrée ou avoir des marges pour s\'adapter à ce format.',
    qualityDetailFail: 'Ce fichier n\'est assez net que pour {{achievedScale}} sur un support de {{outdoorW}} × {{outdoorH}} m.',
    qualityTargetFail: 'Concevez votre visuel à {{w}} × {{h}} cm (échelle 1:{{scale}}, {{dpi}} dpi) pour ce format.',
    recResolutionPx: 'recommandé: {{w}}×{{h}}px @ {{dpi}} dpi',
    dimensionsCalculatorHintPx: "Modifiez la largeur ou la hauteur : l'autre côté se met à jour automatiquement pour conserver ce format, et la résolution DPI effective est recalculée afin de trouver des dimensions alternatives qui conservent une bonne qualité d'impression.",
    dimensionsCalculatorWidthLabelPx: 'Largeur (px)',
    dimensionsCalculatorHeightLabelPx: 'Hauteur (px)',
    dimensionsCalculatorDpiLabelPx: 'DPI effectif',
    dimensionsCalculatorMinDpiHintPx: 'Au moins {{dpi}} dpi sont requis pour ce support extérieur.',
    dimensionsCalculatorMinQualityWidthPx: 'Qualité minimale de largeur pas encore atteinte (min. {{min}}px, recommandé : {{rec}}px).',
    dimensionsCalculatorMinQualityHeightPx: 'Qualité minimale de hauteur pas encore atteinte (min. {{min}}px, recommandé : {{rec}}px).',
    qualityWarnLowRes: 'Faible résolution - l\'image peut s\'imprimer avec une mauvaise qualité',
    qualityConfirmHintLowRes: 'L\'image risque de s\'imprimer avec une perte de qualité visible.',
    qualityDetailWarnPx: '{{pixelW}} × {{pixelH}} px donne {{dpi}} PPP en pleine taille.',
    qualityDetailFailPx: '{{pixelW}} × {{pixelH}} px donne {{dpi}} PPP à {{outdoorW}} × {{outdoorH}} m, en dessous du minimum de {{minDpi}} PPP.',
    qualityTargetWarnPx: 'Nous recommandons au moins {{recDpi}} PPP pour ce format : {{recW}} × {{recH}} px, ou {{recScaleLabel}}.',
    qualityTargetFailPx: 'Vous avez besoin d\'au moins {{minW}} × {{minH}} px - en travaillant à 1:{{scale}}, c\'est un canevas de {{canvasW}} × {{canvasH}} m à {{designDpi}} PPP.',
    creativeUnitLabel: 'Unités de taille',
    creativeUnitCm: 'Centimètres',
    creativeUnitPx: 'Pixels',
    creativeUnitHint: 'Choisissez comment les tailles recommandées des visuels sont affichées et vérifiées. Centimètres : concevez à l\'échelle 1:10 du support, toujours à 300 dpi. Pixels : résolution minimale selon la taille du support.',
    previewBadge: 'Aperçu',
    previewOnlyHint: 'Aperçu uniquement - téléchargez l\'original pour l\'impression',
    downloadPrintFile: 'Télécharger le fichier d\'impression',
    downloadPrintFileHint: 'Original en pleine résolution',
    printFileExplainer: 'L\'image ci-dessus est un aperçu allégé. Téléchargez le fichier original, en pleine résolution, pour l\'envoyer à l\'impression.',
    previewFailed: 'Impossible de préparer un aperçu de ce fichier dans votre navigateur. Exportez-le en JPG ou PNG et réessayez.',
    creativeFileRequirements: 'Fichiers acceptés : TIF, TIFF, JPG, JPEG, PNG ou PDF. L\'impression nécessite le mode colorimétrique CMJN (CMYK). Les images dans un autre mode sont converties en CMJN, avec un aperçu à valider avant l\'envoi. Les fichiers PDF doivent déjà être en CMJN.',
    creativeFormatNotAllowed: '« {{name}} » n\'est pas un type de fichier accepté. Veuillez téléverser un fichier TIF, TIFF, JPG, JPEG, PNG ou PDF.',
    creativeNotCmykPdf: '« {{name}} » contient des couleurs RVB (dans le visuel ou une image intégrée). Les fichiers d\'impression doivent être entièrement en CMJN - exportez-le à nouveau avec un profil colorimétrique CMJN (ex. PDF/X-1a) puis téléversez-le.',
    creativeUnreadable: 'Impossible de lire « {{name}} ». Il est peut-être endommagé ou enregistré de façon inhabituelle - exportez-le à nouveau et réessayez.',
    cmykNoticeTitle: '« {{name}} » n\'est pas en mode CMJN',
    cmykNoticeBody: 'L\'impression nécessite le CMJN. Nous pouvons le convertir pour vous avec le profil de référence pour l\'affichage extérieur, et vous validerez un aperçu avant/après avant tout envoi.',
    cmykConvert: 'Convertir en CMJN',
    cmykModalTitle: 'Convertir en CMJN pour l\'impression',
    cmykConverting: 'Conversion en CMJN ({{profile}})…',
    cmykBefore: 'Original',
    cmykAfter: 'Aperçu d\'impression (CMJN)',
    cmykShiftWarning: 'Certaines couleurs vives seront nettement différentes à l\'impression (environ {{percent}} % de l\'image). Si les couleurs exactes sont importantes, ajustez le visuel dans votre logiciel de création avant de le téléverser.',
    cmykProfileNote: 'Converti avec le profil {{profile}}, la référence pour l\'affichage extérieur. Les écrans ne peuvent pas afficher le CMJN avec exactitude : l\'aperçu simule le rendu imprimé.',
    cmykAccept: 'Accepter la version CMJN convertie',
    cmykErrorUnavailable: 'La conversion en CMJN est temporairement indisponible. Convertissez le fichier en CMJN dans votre logiciel de création puis téléversez-le à nouveau.',
    cmykErrorTooLarge: 'Cette image est trop volumineuse pour être convertie dans le navigateur. Convertissez-la en CMJN dans votre logiciel de création puis téléversez-la à nouveau.',
    cmykErrorFailed: 'Impossible de convertir ce fichier. Convertissez-le en CMJN dans votre logiciel de création puis téléversez-le à nouveau.',
    pay: 'Valider et Payer',
    commission: 'Commission plateforme ({{rate}}%)',
    vatLabel: 'TVA',
    vatWithRate: 'TVA ({{rate}}%)',
    vatDetailsTitle: 'Détails de la TVA',
    vatDetailsBody: "La TVA est calculée selon le régime fiscal applicable à chaque composante de la campagne. Certains montants peuvent inclure la TVA, être soumis à un taux de TVA différent, ou ne pas entrer dans la base d'imposition de la TVA.",
    totalWithoutVat: 'Total (hors TVA)',
    grandTotal: 'Total',
    dailyRateRoundingNote: 'Les tarifs journaliers sont arrondis au centime près.',
    platformFeeNote: '* Les tarifs journaliers des espaces incluent déjà une commission de plateforme de 5%.',
    confirmPayment: 'Confirmer le paiement',
    paymentSuccess: 'Paiement réussi ! Votre campagne sera activée sous peu.',
    checkingPayment: 'Vérification de votre paiement…',
    paymentConfirmed: 'Paiement Confirmé !',
    paymentConfirmedDesc: 'Votre paiement a été confirmé. Votre campagne sera activée sous peu.',
    paymentPending: 'Paiement Non Confirmé',
    paymentPendingDesc: 'Votre paiement n\'a pas pu être confirmé pour le moment. Veuillez réessayer ou contacter le support.',
    backToCampaign: 'Retour à la Campagne',
    expandPricing: 'Afficher les détails des prix',
    collapsePricing: 'Masquer les détails des prix',
    availabilityUpdated: "Un ou plusieurs emplacements ont été retirés de votre campagne - ils ont été réservés par une autre campagne pour des dates chevauchantes, ou leur période de préavis minimale avait déjà expiré. Veuillez consulter la sélection mise à jour ci-dessous.",
    availabilityDialogTitle: 'Confirmer la disponibilité et procéder au paiement',
    availabilityDialogBody: 'Avant de continuer, nous vérifierons que tous les espaces sélectionnés sont toujours disponibles. Certains ont peut-être été réservés par d\'autres campagnes. Veuillez indiquer comment gérer les conflits.',
    availabilityRemoveYes: 'Oui - supprimer automatiquement les espaces indisponibles',
    availabilityRemoveYesDesc: 'Les espaces qui ne sont plus disponibles seront retirés de cette campagne. Vous pourrez vérifier la sélection mise à jour avant de payer.',
    availabilityRemoveNo: 'Non - signaler les conflits et les examiner manuellement',
    availabilityRemoveNoDesc: 'Les espaces en conflit seront mis en évidence afin que vous puissiez ajuster leurs dates ou les supprimer manuellement.',
    availabilityDialogConfirm: 'Procéder au paiement',
    outdoorFlaggedTitle: 'Dates plus disponibles',
    outdoorFlaggedDesc: 'Cet espace a été réservé par une autre campagne pour des dates qui se chevauchent. Modifiez les dates ou supprimez-le pour continuer.',
    outdatedOutdoorsTitle: 'La campagne ne peut pas continuer - des emplacements obsolètes ont été détectés',
    outdatedOutdoorsDesc: 'Un ou plusieurs emplacements ont une date de début déjà passée. Le paiement n\'a pas été traité. Veuillez examiner les emplacements signalés ci-dessous et mettre à jour leurs dates avant de réessayer.',
    outdoorOutdatedTitle: 'Date de début dépassée',
    outdoorOutdatedDesc: 'La date de début programmée pour cet emplacement est déjà passée. Veuillez la mettre à jour avec une date future pour continuer.',
    pastStartDatesToast: 'Les dates de la campagne ne peuvent pas être dans le passé.',
    cancelCampaign: 'Annuler la campagne',
    cancelCampaignConfirm: 'Cette action annulera définitivement votre campagne. Êtes-vous sûr ?',
    cancelCampaignYes: 'Oui, annuler',
    cancelCampaignAbort: 'Conserver la campagne',
    cancelledSuccess: 'La campagne a été annulée.',
    cancellationPolicyPending: 'Annulation gratuite - aucun frais n\'est appliqué tant que votre campagne est en statut En attente.',
    cancellationPolicyReady: 'Annulation gratuite si tous les outdoors sont annulés avec plus de jours de préavis que le délai minimum du Fournisseur d\'Espaces concerné. Des frais d\'annulation s\'appliquent si un ou plusieurs outdoors se trouvent dans leur délai de préavis minimum (plus TVA pour les entreprises portugaises). Les frais de production (impression, installation, etc.) ne sont pas remboursables pour tout outdoor dans son délai de préavis minimum.',
    cancellationPolicyRunning: 'Attention : l\'annulation d\'une campagne déjà en cours entraîne la perte de 100 % de la valeur de la campagne. Aucun remboursement ne sera accordé.',
    ppInvoices: 'Factures des Fournisseurs d\'Espace',
    outdoorAdj0: 'incroyables',
    outdoorAdj1: 'formidables',
    outdoorAdj2: 'magnifiques',
    outdoorAdj3: 'fabuleux',
    outdoorAdj4: 'exceptionnels',
    outdoorsCollapsedSummary: 'Nous avons ici {{count}} outdoors {{adj}} !',
    messages: 'Messages',
    noMessages: 'Aucun fournisseur d\'espaces n\'a encore envoyé de messages concernant cette campagne. Dès qu\'ils le feront, leurs conversations apparaîtront ici.',
    noMessagesYet: 'Aucun message dans cette conversation pour l\'instant.',
    typeMessage: 'Rédigez un message…',
    instructions: 'Instructions pour les Fournisseurs d\'Espaces',
    instructionsPlaceholder: 'ex. Veuillez afficher cette campagne de 8h à 22h seulement.',
    instructionsEmpty: 'Aucune instruction ajoutée. Cliquez sur Modifier pour ajouter des indications.',
    instructionsSaved: 'Instructions enregistrées.',
    proofOfDisplay: "Preuve d'affichage",
    proofPending: 'Preuve à venir',
    proofPendingDesc: "Votre prestataire d'espace téléchargera la preuve d'affichage sous peu.",
    proofAlt: "Preuve d'affichage – {{name}}",
    additionalFiles: 'Fichiers supplémentaires',
    additionalFilesSubtitle: 'Supports complémentaires pour cette campagne - non obligatoires.',
    additionalFilesSubtitlePP: "Supports partagés par l'annonceur.",
    noAdditionalFiles: "Aucun fichier supplémentaire n'a encore été téléchargé.",
    uploadFile: 'Télécharger un fichier',
    fileUploaded: 'Fichier téléchargé avec succès.',
    fileDeleted: 'Fichier supprimé.',
    deleteFile: 'Supprimer le fichier',
    addOutdoors: 'Ajouter des espaces',
    creativesLockedTitle: 'Aucun espace ajouté',
    creativesLockedDesc: 'Les visuels doivent correspondre à la résolution requise de chaque espace. Ajoutez au moins un espace pour débloquer les téléversements.',
    editDates: 'Modifier les dates',
    updateDates: 'Mettre à jour les dates',
    datesUpdated: 'Dates mises à jour avec succès',
  },
  dashboard: {
    title: 'Tableau de bord',
    earnings: 'Revenus',
    spendings: 'Dépenses',
    last30: '30 derniers jours',
    last90: '90 derniers jours',
    thisYear: 'Cette année',
    accessRequests: "Demandes d'accès",
    noRequests: 'Aucune demande en attente',
    approve: 'Approuver',
    reject: 'Rejeter',
    teamInvite: "Inviter un membre de l'équipe",
    inviteEmail: 'Adresse e-mail',
    sendInvite: "Envoyer l'invitation",
    totalEarned: 'Total gagné',
    totalSpent: 'Total dépensé',
    activeOutdoors: 'Panneaux actifs',
    activeCampaigns: 'Campagnes actives',
    overview: 'Aperçu',
    howPaidTitle: 'Comment vous êtes payé',
    howPaidDesc: 'Une fois une campagne lancée, téléchargez des preuves photo pour chaque panneau. Une fois toutes les preuves vérifiées, votre paiement est libéré automatiquement. Votre versement est calculé sur la base de votre tarif journalier multiplié par le nombre de jours actifs de la campagne, net de frais de service plateforme de 5 % appliqués par réservation.',
    ppOverview: "Vue d'ensemble du Fournisseur d'espaces",
    advertiserOverview: "Vue d'ensemble de l'Annonceur",
    findOutdoors: 'Trouver des panneaux',
    addOutdoor: 'Ajouter un panneau',
    viewCampaigns: 'Voir les campagnes',
    manageOutdoors: 'Gérer les panneaux',
    companyDetails: "Détails de l'entreprise",
    userDetails: 'Informations du compte',
    pendingRequests: "Demandes d'accès en attente ({{count}})",
    inviteDesc: "Ils recevront un e-mail avec un lien pour rejoindre votre entreprise sur Scapow.",
    invitePlaceholder: 'collegue@entreprise.com',
    invoicesTitle: 'Factures',
    downloadInvoice: 'Télécharger',
    invoiceIssued: 'Émise',
    invoicePaid: 'Payée',
    invoiceUnknownCampaign: 'Campagne inconnue',
    invoicesSubtitle: 'Votre historique de paiements et vos factures téléchargeables.',
    invoicesEmpty: 'Nous avons hâte de remplir cette section pour vous !',
  },
  invoices: {
    title: 'Factures',
    subtitleAdvertiser: 'Factures Scapow et des prestataires pour toutes vos campagnes.',
    subtitlePP: 'Votre historique de paiements et vos factures téléchargeables.',
    issued: 'Émise le',
    download: 'Télécharger',
    empty: 'Aucune facture pour le moment. Elles apparaîtront ici une fois vos campagnes traitées.',
    unknownCampaign: 'Campagne inconnue',
    ppInvoices: 'Factures prestataires ({{count}})',
    unknownProvider: 'Prestataire inconnu',
    notAvailable: 'Non disponible',
    typeInvoice: 'Facture',
    typeCreditNote: 'Avoir',
  },
  payments: {
    title: 'Paiements',
    subtitle: 'Votre historique de paiements pour les campagnes diffusées sur vos supports.',
    empty: 'Aucun paiement pour le moment. Ils apparaîtront ici une fois vos campagnes réglées.',
    unknownCampaign: 'Campagne inconnue',
    columnId: 'ID de paiement',
    columnCampaign: 'Campagne',
    columnValue: 'Montant',
    columnPaidAt: 'Payé le',
    columnStatus: 'Statut',
    statusPaid: 'Payé',
    statusTransferRequested: 'Virement demandé',
  },
  userDetails: {
    receiveEmails: 'Recevoir des e-mails',
    receiveEmailsOnDesc: 'Les e-mails de la plateforme sont envoyés à {{email}}.',
    receiveEmailsOffDesc: 'Vous ne recevrez pas d’e-mails de la plateforme. Activez cette option pour les recevoir à nouveau.',
    emailsTurnedOn: 'Vous recevrez les e-mails de la plateforme.',
    emailsTurnedOff: 'Vous ne recevrez plus d’e-mails de la plateforme.',
    emailsUpdateError: 'Impossible de mettre à jour votre préférence d’e-mails.',
    title: 'Informations du compte',
    subtitle: 'Gérez les informations de votre compte personnel.',
    name: 'Nom',
    editName: 'Cliquez pour modifier',
    email: 'E-mail',
    memberSince: 'Membre depuis (UTC)',
    accountStatus: 'Statut du compte',
    statusVerified: 'Vérifié',
    statusPending: 'Vérification en attente',
    nameUpdated: 'Nom mis à jour avec succès.',
    nameRequired: 'Veuillez saisir un nom valide (au moins 2 caractères).',
    password: 'Mot de passe',
    changePassword: 'Changer le mot de passe',
    currentPassword: 'Mot de passe actuel',
    newPassword: 'Nouveau mot de passe',
    confirmNewPassword: 'Confirmer le nouveau mot de passe',
    passwordUpdated: 'Mot de passe mis à jour avec succès.',
    passwordFieldsRequired: 'Veuillez remplir tous les champs du mot de passe.',
    passwordTooShort: 'Le nouveau mot de passe doit contenir au moins 8 caractères.',
    passwordSameAsCurrent: 'Le nouveau mot de passe doit être différent du mot de passe actuel.',
    passwordMismatch: 'Le nouveau mot de passe et la confirmation ne correspondent pas.',
  },
  admin: {
    tabUnpaidInstallments: 'Échéances impayées',
    unpaidInstallmentsIntro: 'Échéances toujours impayées 6 jours après leur date d’échéance, les plus anciennes d’abord.',
    noUnpaidInstallments: 'Aucune échéance impayée.',
    installmentOf: 'Échéance {{number}} sur {{total}}',
    installmentNumber: 'Échéance {{number}}',
    installmentDue: 'Échue le {{date}}',
    installmentOverdueDays_one: '{{count}} jour de retard',
    installmentOverdueDays_other: '{{count}} jours de retard',
    proofOfCompany: 'Justificatif d’entreprise',
    openProofOfCompany: 'Ouvrir {{name}} dans un nouvel onglet',
    noProofOfCompany: 'Aucun justificatif d’entreprise importé',
    proofLocationLoading: 'Recherche de l’adresse…',
    proofLocationViewMap: 'Voir sur la carte',
    title: "Panneau d'administration",
    verifications: 'Vérifications',
    advertisers: 'Annonceurs',
    providers: 'Fournisseurs',
    payments: 'Paiements',
    noVerifications: 'Aucune vérification en attente',
    noPayments: 'Aucun paiement en attente',
    markAsDone: 'Marquer comme terminé',
    business: 'Entreprise',
    type: 'Type',
    status: 'Statut',
    actions: 'Actions',
    approve: 'Approuver',
    reject: 'Rejeter',
    subtitle: 'Gestion et modération de la plateforme',
    proofVerification: 'Vérifications Manuelles',
    accessRequestsTab: "Demandes d'accès",
    noAccessRequests: "Aucune demande d'accès en attente.",
    noAdvertisers: 'Aucun annonceur trouvé.',
    noProviders: 'Aucun fournisseur trouvé.',
    noPaymentsStatus: 'Aucun paiement avec ce statut.',
    campaignOutdoor: 'Panneau de campagne : {{id}}',
    campaignFrom: 'Campagne du {{date}}',
    adCreative: 'Créatif publicitaire',
    proofPhotos: 'Photos de preuve ({{count}}) - cliquez pour ouvrir en taille réelle',
    period: 'Période',
    outdoorsLabel: 'panneaux',
    campaignsLabel: 'campagnes',
    spentLabel: 'dépensé',
    earnedLabel: 'gagné',
    markAsPaid: 'Marquer comme payé',
    tabAds: 'Annonces',
    tabBusinessProofs: "Preuves d'Entreprise",
    tabProofOfAds: "Preuves d'Annonces",
    approved: 'Approuvé',
    rejected: 'Rejeté',
    noAds: "Aucune vérification d'annonce en attente.",
    noBusinessProofs: "Aucune preuve d'entreprise en attente.",
    noProofOfAds: "Aucune preuve d'annonce en attente.",
    refundsTab: 'Remboursements & Dettes',
    refundsSearchPlaceholder: 'Rechercher par nom de campagne ou d’annonceur…',
    refundsNoCampaigns: 'Aucune campagne trouvée.',
    refundsSelectOutdoors: 'Sélectionner les outdoors à rembourser',
    refundsSelectAll: 'Tout sélectionner',
    refundsDeselectAll: 'Tout désélectionner',
    refundsNoEligible: 'Aucun outdoor éligible trouvé pour cette campagne.',
    refundsEligibleNote: 'Seuls les outdoors non rejetés sont éligibles au remboursement.',
    refundsSubmit: 'Traiter le remboursement',
    refundsSuccess: 'Remboursement traité avec succès.',
    refundsSubTabRefunds: 'Remboursements Annonceurs',
    refundsSubTabDebts: 'Dettes Prestataires',
    refundTypeTotal: 'Total',
    refundTypePartial: 'Partiel',
    refundDaysLabel: 'Jours à rembourser',
    refundDaysHint: 'Max {{max}} jours',
    debtNoDebts: 'Aucune dette prestataire en cours.',
    debtSettle: 'Régler',
    debtSettleAmount: 'Montant du règlement',
    debtSettleDoc: 'Document de règlement',
    debtSettleDocHint: 'Téléversez le document de règlement signé (PDF, image, etc.)',
    debtSettleConfirm: 'Téléverser et régler',
    debtSettleSuccess: 'Dette réglée et document téléversé avec succès.',
    debtStatusOutstanding: 'En cours',
    debtStatusSettled: 'Réglé',
    debtCampaign: 'Campagne',
    campaignsTab: 'Campagnes',
    noCampaigns: 'Aucune campagne trouvée.',
    accessRequestFor: "Demande d'accès à : {{entity}}",
    tabByStatus: 'Par statut',
    tabTransferRequested: 'Virement demandé',
    checkPayment: 'Vérifier',
    lastCheckedAt: 'Dernière vérification',
    neverChecked: 'Jamais vérifié',
    noTransferRequested: 'Aucun paiement avec virement demandé.',
    checkSuccess: 'Vérification du paiement initiée.',
    revenueTitle: 'Revenus',
    revenueSubtitle: 'Commission de la plateforme et TVA par période de facturation',
    revenueGross: 'Revenu brut',
    revenueCommission: 'Commission',
    revenueVat: 'TVA',
    revenueStripeFees: 'Frais Stripe',
    revenueNet: 'Revenu net',
    revenueEmpty: 'Aucun revenu enregistré pour cette période.',
    revenueMonth: 'Mois',
    revenueYear: 'Année',
    revenueDailyTitle: 'Détail Quotidien',
    revenueNoDaily: 'Aucune donnée quotidienne pour cette période.',
    searchByName: 'Rechercher par nom…',
    importOutdoorsFromFile: 'Importer des affichages depuis un fichier',
    chooseFile: 'Choisir un fichier…',
    csvSend: 'Envoyer',
    importOutdoorsSuccess: 'Fichier d\'affichage envoyé avec succès.',
    remainingFreeCommissions: 'Commissions gratuites restantes : {{count}}',
    setFreeCommissions: 'Définir les nouvelles commissions gratuites restantes',
    freeCommissionsUpdated: 'Commissions gratuites restantes mises à jour.',
    freeCommissionsUpdateFailed: 'Impossible de mettre à jour les commissions gratuites restantes.',
    verified: 'Vérifié',
  },
  ppCampaigns: {
    searchAllStatuses: 'Campagnes de tous les statuts affichées. Effacez la recherche pour filtrer par statut.',
    typeAll: 'Toutes',
    typeScapow: 'Scapow',
    typeOffline: 'Hors ligne',
    typeFilterLabel: 'Type de campagne',
    noOfflineResults: 'Pas encore de campagne hors ligne. Ajoutez des espaces à une campagne depuis votre page Espaces.',
    goToOutdoors: 'Aller aux Espaces',
    offlineBadge: 'Hors ligne',
    moreOutdoors: '+{{count}} de plus',
    offlineNotes: 'Notes',
    payoutCommission: 'Commission de la plateforme',
    payoutCommissionVat: 'TVA sur la commission de la plateforme',
    payoutTransferred: 'Viré',
    payoutValueWithoutVat: 'Valeur publicitaire (HT)',
    payoutVat: 'TVA',
    payoutProduction: 'Coûts de production (TTC)',
    payoutsTitle: 'Versements',
    payoutsCount: 'Versements : {{count}}',
    payoutsReceived: 'Reçu à ce jour',
    payoutFull: 'Versement intégral',
    payoutFirst: 'Premier versement · {{month}}',
    payoutAfterProof: 'Prévu à partir du {{date}}, après validation de la preuve d’affichage',
    payoutExpectedOn: 'Prévu le {{date}}',
    payoutReceivedOn: 'Reçu le {{date}}',
    payoutProcessing: 'Virement en cours',
    payoutOnHold: 'En attente - le prélèvement de l’annonceur a échoué',
    payoutsOnHoldNotice: 'Un versement est en attente car le prélèvement de l’annonceur a échoué. Il sera libéré dès que ce paiement aboutira.',
    payoutsNetNote: 'Montants nets de la commission Scapow et de sa TVA, avant toute dette en cours.',
    colProduction: 'Production',
    title: 'Campagnes',
    subtitle: 'Suivez et gérez les campagnes qui incluent vos espaces outdoor.',
    tabPending: 'En attente',
    tabReady: 'Prêtes',
    tabRunning: 'En cours',
    tabCompleted: 'Terminées',
    noResults: 'Aucune campagne trouvée pour ce statut.',
    outdoorSlots: '{{count}} espace outdoor',
    outdoorSlots_plural: '{{count}} espaces outdoor',
    instructions: "Instructions de l'annonceur",
    backToCampaigns: 'Retour aux Campagnes',
    yourSlots: 'Vos Espaces Outdoor',
    noSlots: "Aucun espace outdoor de vos emplacements trouvé dans cette campagne.",
    advertiserInstructions: "Instructions de l'Annonceur",
    messagesWithAdvertiser: "Messages avec l'Annonceur",
    noConversation: "Pas encore de messages. Commencez une conversation avec l'annonceur en tapant ci-dessous.",
    myInvoice: "Ma Facture à l'Annonceur",
    uploadInvoice: 'Téléverser la facture',
    replaceInvoice: 'Remplacer la facture',
    uploadInvoiceSuccess: 'Facture téléversée avec succès.',
    invoiceUploaded: 'Voir la facture',
    noInvoiceYet: "Aucune facture n'a encore été téléversée.",
    creativesAndOutdoors: 'Créatifs & vos emplacements',
    noCreativeForRatio: "Aucun créatif n'a encore été téléversé pour ce format.",
    yourOutdoorsForFormat: 'Vos emplacements pour ce format',
    viewOutdoor: "Voir l'emplacement",
    goToCampaign: 'Aller à la page de la campagne',
    yourEarnings: 'Vos revenus',
    readyPaymentTitle: 'Vérification des affichages requise',
    readyPaymentNoteReady: 'Vos revenus sont sécurisés dans l\'attente du lancement de la campagne. Une fois celle-ci active, téléchargez la preuve d\'installation pour chaque emplacement afin d\'initier le paiement.',
    readyPaymentNote: 'Pour débloquer vos revenus, téléchargez la preuve d\'installation de chaque emplacement via l\'étape Vérifier les affichages.',
    readyPaymentCta: 'Aller à Vérifier les affichages',
    paymentPaidTitle: 'Paiement reçu',
    paymentPaidDesc: 'Vos revenus pour cette campagne ont été versés.',
    viewBreakdown: 'voir le détail',
    earningsBreakdown: 'Détail des revenus',
    colDays: 'Jours',
    colNetDailyValue: 'Valeur Journalière + TVA',
    colEarnings: 'Revenus',
  },
  upcomingCampaigns: {
    title: 'Campagnes à Venir',
    subtitle: 'Campagnes prêtes à lancer incluant vos espaces publicitaires.',
    noResults: 'Aucune campagne à venir trouvée.',
  },
  getPaid: {
    title: 'Être Payé',
    subtitle: 'Suivez les étapes ci-dessous pour vérifier vos affichages et recevoir votre paiement.',
    step1: { label: 'Campagnes à Venir', desc: 'Récupérez les Créatifs pour configurer les Panneaux' },
    step2: { label: 'Vérifier les Affichages', desc: "Téléversez une preuve d'affichage pour être payé" },
    step3: { label: 'Factures Payées', desc: 'Votre historique de paiements' },
    paidOn: 'Payé le',
    downloadInvoice: 'Facture',
    noPayments: "Aucun paiement pour l'instant",
    noPaymentsDesc: "Complétez l'étape de vérification pour débloquer le paiement.",
    upcomingEmpty: 'Aucune campagne à venir pour le moment. Revenez plus tard.',
    goToVerify: 'Aller à Vérifier les Affichages',
    goToPaid: 'Voir les Paiements',
    goToUpcoming: 'Voir les Campagnes à Venir',
  },
  cart: {
    title: 'Votre panier',
    empty: 'Votre panier est vide',
    emptyDesc:
      'Recherchez des espaces publicitaires et ajoutez-les à votre panier pour créer une campagne.',
    browseOutdoors: 'Explorer les panneaux',
    campaignDetails: 'Détails de la campagne',
    campaignName: 'Nom de la campagne',
    description: 'Description (optionnel)',
    subtotal: 'Sous-total',
    total: 'Total',
    remove: 'Supprimer',
    placeOrder: 'Créer la campagne',
    creating: 'Création…',
    estimatedCost: 'Coût estimé',
    signInTitle: 'Connectez-vous pour continuer',
    signInDesc: 'Créez un compte ou connectez-vous pour créer votre campagne.',
    buildCampaign: 'Créer une campagne',
    estimatedTotal: 'Total estimé',
    campaignNamePlaceholder: 'Campagne Été 2026',
    detailsPlaceholder: 'Des notes...',
    campaignLabel: 'Campagne {{n}}',
    selectCampaign: 'Ajouter à la campagne :',
    signInToCheckout: 'Connectez-vous pour créer cette campagne',
    advertiserRequired: 'Vous avez besoin d\'un compte Annonceur pour créer des campagnes',
    instructions: 'Instructions pour les Fournisseurs d\'Espaces (optionnel)',
    instructionsPlaceholder: 'Les instructions spéciales pour les Fournisseurs d\'Espaces doivent être indiquées ici...',
    instructionsHint: 'Vous pouvez mettre à jour ce champ après la création de la campagne.',
  },
  invitations: {
    title: 'Invitations Utilisateurs',
    subtitle: 'Gérer les invitations des membres de votre équipe',
    pendingTitle: 'Invitations en attente',
    noPending: 'Aucune invitation en attente',
    noPendingDesc: "Invitez un membre de l'équipe ci-dessus pour commencer.",
    sentAt: 'Envoyé',
    cancel: 'Annuler',
    inviteSuccess: 'Invitation envoyée avec succès.',
    inviteError: "Échec de l'envoi de l'invitation.",
    cancelSuccess: 'Invitation annulée.',
    formTitle: "Inviter un membre de l'équipe",
    formDesc: 'Ils recevront un e-mail avec un lien pour rejoindre votre entreprise sur Scapow.',
    formPlaceholder: 'collegue@entreprise.com',
    formSend: "Envoyer l'invitation",
  },
  terms: {
    back: 'Retour',
    title: 'Conditions Générales d\'Utilisation',
    effectiveDate: 'Date d\'entrée en vigueur : 19 juin 2026 · SCAPOW · Codify, Unipessoal Lda',
    introBanner: 'En créant un compte, en accédant ou en utilisant la Plateforme, vous acceptez d\'être légalement lié par ces Conditions. Si vous n\'êtes pas d\'accord, vous ne devez pas utiliser la Plateforme.',
    footerNote: 'SCAPOW · Codify, Unipessoal Lda · En vigueur depuis le 19 juin 2026',
    s1: 'Introduction',
    s1_p1: 'Ces Conditions Générales d\'Utilisation (« Conditions ») régissent l\'accès et l\'utilisation de la plateforme SCAPOW (« Plateforme »), exploitée par Codify, Unipessoal Lda (« Société », « nous », « notre »).',
    s1_p2: 'La Plateforme fonctionne comme un marché numérique mettant en relation :',
    s1_i1Bold: 'les Annonceurs',
    s1_i1Rest: ', qui cherchent à acheter des espaces publicitaires pour des campagnes marketing ; et',
    s1_i2Bold: 'les Fournisseurs d\'Espaces',
    s1_i2Rest: ', qui possèdent, exploitent ou contrôlent des espaces publicitaires physiques, y compris mais sans s\'y limiter les panneaux d\'affichage, enseignes extérieures, écrans numériques et autres supports.',
    s2: 'Eligibilité',
    s2_p1: 'Les utilisateurs doivent :',
    s2_i1: 'Avoir au moins 18 ans ;',
    s2_i2: 'Avoir la capacité juridique de conclure des accords contraignants ;',
    s2_i3: 'Fournir des informations exactes et complètes lors de l\'inscription ;',
    s2_i4: 'Respecter toutes les lois et réglementations applicables.',
    s2_p2: 'Les utilisateurs professionnels déclarent être autorisés à engager leur entreprise ou organisation.',
    s3: 'Rôles des Utilisateurs',
    s3_1: '3.1 Annonceurs',
    s3_1_p1: 'Les Annonceurs peuvent :',
    s3_1_i1: 'Rechercher, sélectionner et acheter des espaces publicitaires ;',
    s3_1_i2: 'Télécharger des supports publicitaires ;',
    s3_1_i3: 'Lancer et gérer des campagnes.',
    s3_1_p2: 'Les Annonceurs sont seuls responsables de :',
    s3_1_i4: 'La légalité de leur contenu publicitaire ;',
    s3_1_i5: 'La propriété ou l\'autorisation de toute propriété intellectuelle utilisée ;',
    s3_1_i6: 'Le respect des lois sur la publicité.',
    s3_2: '3.2 Fournisseurs d\'Espaces',
    s3_2_p1: 'Les Fournisseurs d\'Espaces peuvent :',
    s3_2_i1: 'Lister les espaces publicitaires disponibles ;',
    s3_2_i2: 'Fixer les tarifs, la disponibilité des campagnes et les exigences opérationnelles ;',
    s3_2_i3: 'Accepter les placements de campagnes.',
    s3_2_p2: 'Les Fournisseurs d\'Espaces déclarent et garantissent qu\'ils :',
    s3_2_i4: 'Possèdent ou contrôlent légalement l\'espace publicitaire ;',
    s3_2_i5: 'Disposent de tous les permis, licences et droits nécessaires à une utilisation publicitaire commerciale ;',
    s3_2_i6: 'Peuvent exécuter les campagnes réservées dans les délais convenus.',
    s3_3: '3.3 Déclaration Légale pour le Référencement d\'Espaces Publicitaires',
    s3_3_p1: 'Lors du référencement d\'un espace publicitaire extérieur sur la Plateforme, chaque Fournisseur d\'Espaces doit confirmer expressément, au moment de la soumission, que :',
    s3_3_i1: 'Il détient les droits légaux sur l\'espace publicitaire soumis ;',
    s3_3_i2: 'Il est autorisé à le proposer à des fins commerciales ;',
    s3_3_i3: 'Le référencement est conforme à toutes les lois, permis, licences, règlements d\'urbanisme et exigences des autorités locales applicables.',
    s3_3_p2: 'Cette déclaration est une condition de référencement. Les soumissions sans cette confirmation ne seront pas acceptées. La Plateforme se réserve le droit de supprimer tout référencement dont la déclaration s\'avère fausse ou trompeuse, et de suspendre ou résilier le compte de tout Fournisseur d\'Espaces fournissant des informations inexactes.',
    s4: 'Rôle de la Plateforme',
    s4_p1: 'La Plateforme agit uniquement en tant qu\'intermédiaire et facilitateur. La Société :',
    s4_i1: 'Ne possède pas d\'espaces publicitaires ;',
    s4_i2: 'N\'agit pas en tant qu\'annonceur ou fournisseur d\'espaces ;',
    s4_i3: 'Ne garantit pas les performances des campagnes, les impressions ni les résultats commerciaux ;',
    s4_i4: 'N\'est pas responsable de l\'installation ou du retrait physique des publicités.',
    s4_p2: 'Chaque transaction établit une relation contractuelle directe entre l\'Annonceur et le Fournisseur d\'Espaces.',
    s5: 'Réservations de Campagne',
    s5_p1: 'Une réservation de campagne devient contraignante dès que :',
    s5_i1: 'L\'Annonceur a finalisé le paiement - en réglant l\'intégralité ou, pour une campagne payée en plusieurs fois, en autorisant le premier paiement et le prélèvement des échéances suivantes ;',
    s5_i2: 'Chaque emplacement publicitaire est confirmé - immédiatement pour les emplacements en réservation instantanée, ou par son Fournisseur d\'Espaces dans le délai de confirmation ;',
    s5_i3: 'La date de début de campagne est programmée.',
    s5_p2: 'Toutes les réservations sont soumises au délai de préavis minimum spécifié par le Fournisseur d\'Espaces. Ce délai détermine le moment le plus tardif auquel un Annonceur peut soumettre et payer une campagne. Le non-respect peut entraîner un refus ou un report.',
    s6: 'Conditions de Paiement',
    s6_1: '6.1 Paiements des Annonceurs',
    s6_1_p1: 'Les Annonceurs paient selon le mode de paiement choisi lors de la commande :',
    s6_1_i1: 'Paiement intégral - le montant total de la campagne est débité lors de la commande ;',
    s6_1_i2: 'Mensuel ou tous les trois mois - les coûts de production et la première période de facturation sont débités lors de la commande, et chaque période de facturation suivante est prélevée le premier jour de celle-ci. Ces modes ne sont disponibles que lorsque la campagne s\'étend au-delà de sa première période de facturation.',
    s6_1_p2: 'La commande doit être finalisée avant la date de début de la campagne et avant l\'expiration du délai de préavis minimum du Fournisseur d\'Espaces. Lorsque les emplacements publicitaires nécessitent une confirmation, le paiement est seulement autorisé lors de la commande et débité une fois ceux-ci confirmés, et uniquement pour les emplacements confirmés. Le retard de paiement de toute échéance est régi par la section 6.4. Si la commande n\'est pas finalisée à temps :',
    s6_1_i3: 'La réservation peut être automatiquement annulée ;',
    s6_1_i4: 'Le Fournisseur d\'Espaces n\'est pas tenu de réserver l\'espace publicitaire.',
    s6_2: '6.2 Frais de Plateforme',
    s6_2_p1: 'La Plateforme peut facturer des frais de service, des commissions ou des frais de transaction. Ces frais seront communiqués avant l\'achat. Les frais de Plateforme sont non remboursables sauf obligation légale.',
    s6_3: '6.3 Versements aux Fournisseurs d\'Espaces',
    s6_3_p1: 'Les Fournisseurs d\'Espaces ne sont éligibles au paiement qu\'après :',
    s6_3_i1: 'L\'installation complète des supports publicitaires ;',
    s6_3_i2: 'Le téléchargement de la preuve d\'installation sur la Plateforme ;',
    s6_3_i3: 'L\'approbation de cette preuve ou l\'absence de contestation dans le délai de révision applicable.',
    s6_3_p2: 'La preuve doit inclure des éléments photographiques clairs montrant la campagne correctement affichée. La Plateforme se réserve le droit de vérifier l\'authenticité. Les paiements peuvent être retardés, retenus ou annulés en cas de fraude, litige ou inexécution.',
    s6_4: '6.4 Obligations de Paiement et Retard de Paiement',
    s6_4_p1: 'Chaque réservation confirmée constitue une obligation de paiement ferme de l\'Annonceur. L\'Annonceur doit régler, intégralement et à leur échéance, toutes les sommes dues au titre des campagnes et emplacements publicitaires qu\'il a réservés, y compris chaque échéance d\'une campagne payée en plusieurs fois (mensuellement ou tous les trois mois).',
    s6_4_i1: 'Toute somme non réglée à son échéance - y compris un prélèvement rejeté, retourné ou annulé - est exigible à compter de cette date. La Plateforme en informera l\'Annonceur et pourra procéder à une nouvelle tentative de recouvrement.',
    s6_4_i2: 'Lorsqu\'une somme relative à une campagne demeure impayée plus de deux (2) mois après son échéance, le Fournisseur d\'Espaces peut, sans engager sa responsabilité envers l\'Annonceur, retirer les visuels de l\'Annonceur des emplacements publicitaires concernés et les mettre à la disposition d\'autres annonceurs.',
    s6_4_i3: 'Ce retrait ne libère pas l\'Annonceur de ses obligations : toutes les sommes déjà échues, ainsi que les frais applicables en vertu de la section 9.3, restent intégralement dues.',
    s6_4_i4: 'La Plateforme et/ou le Fournisseur d\'Espaces peuvent engager toute action en justice afin de recouvrer les sommes impayées, majorées des intérêts de retard au taux légal applicable et des frais raisonnables de recouvrement et de procédure, dans la mesure permise par la loi applicable.',
    s6_4_i5: 'La Plateforme peut également suspendre le compte de l\'Annonceur et refuser toute nouvelle réservation jusqu\'au règlement de l\'ensemble des sommes échues, conformément à la section 15.',
    s6_4_p2: 'Le retrait des visuels en application de la présente section ne constitue pas une inexécution du Fournisseur d\'Espaces au sens des sections 9.4 et 9.5 et n\'ouvre droit à aucun remboursement.',
    s7: 'Supports de Campagne',
    s7_p1: 'Les Annonceurs doivent soumettre les supports de campagne dans le délai requis. Les supports doivent :',
    s7_i1: 'Répondre aux spécifications techniques ;',
    s7_i2: 'Être imprimables et utilisables ;',
    s7_i3: 'Être conformes aux lois applicables ;',
    s7_i4: 'Ne pas contenir de contenu illégal, diffamatoire, offensant ou contrefaisant.',
    s7_p2: 'Les Fournisseurs d\'Espaces peuvent rejeter les supports non conformes. La Plateforme peut supprimer tout contenu à sa seule discrétion.',
    s8: 'Preuve d\'Installation',
    s8_p1: 'Les Fournisseurs d\'Espaces doivent télécharger la preuve d\'installation rapidement après installation. Le défaut de preuve peut entraîner :',
    s8_i1: 'Un retard de paiement ;',
    s8_i2: 'L\'annulation du versement ;',
    s8_i3: 'La suspension de la Plateforme.',
    s8_p2: 'Les Annonceurs peuvent contester la preuve dans le délai de litige applicable après le téléchargement. Sans contestation dans ce délai, la preuve est réputée acceptée.',
    s9: 'Annulations et Remboursements',
    s9_1: '9.1 Annulation par l\'Annonceur',
    s9_1_p1: 'Si un Annonceur annule :',
    s9_1_i1: 'Avant le délai de préavis minimum du Fournisseur d\'Espaces : remboursement possible, moins les frais applicables ;',
    s9_1_i2: 'Après le début du délai de préavis : le remboursement peut être refusé.',
    s9_1_p2: 'Les coûts de production, d\'impression et de préparation peuvent ne pas être remboursables.',
    s9_2: '9.2 Annulation par le Fournisseur d\'Espaces',
    s9_2_p1: 'Si un Fournisseur d\'Espaces annule une réservation confirmée sans motif valable :',
    s9_2_i1: 'L\'Annonceur recevra un remboursement intégral ;',
    s9_2_i2: 'Le Fournisseur d\'Espaces pourra subir des pénalités, une réduction de visibilité, une suspension ou une résiliation de compte.',
    s9_3: '9.3 Politique d\'annulation de campagne',
    s9_3_i1: 'Les campagnes en statut En attente peuvent être annulées sans frais à tout moment avant le paiement.',
    s9_3_i5: 'Lorsque la date d\'annulation est antérieure à la date de début de chaque activation outdoor d\'un nombre de jours supérieur au délai de préavis minimum du Fournisseur d\'Espaces concerné, aucun frais d\'annulation ne s\'applique et l\'Annonceur est intégralement remboursé de l\'ensemble des montants versés.',
    s9_3_i2: 'Une fois le paiement effectué, des frais d\'annulation de 30 % de la valeur totale de la campagne s\'appliquent lorsqu\'une ou plusieurs activations d\'outdoor de la campagne tombent dans le délai de préavis minimum donné par le Fournisseur d\'Espaces concerné.',
    s9_3_i3: 'Pour les entreprises enregistrées au Portugal, le taux de TVA applicable sera appliqué aux frais d\'annulation.',
    s9_3_i4: 'Lorsqu\'une ou plusieurs activations d\'outdoor tombent dans le délai de préavis minimum donné par le Fournisseur d\'Espaces, les frais d\'installation et d\'impression ne sont pas remboursables.',
    s9_3_i6: 'L\'annulation d\'une campagne déjà en cours entraîne la perte de 100 % de la valeur de la campagne. Aucun remboursement ne sera accordé.',
    s9_3_i7: 'Lorsque les frais d\'annulation de 30 % s\'appliquent, 20 % de la valeur totale de la campagne seront transférés aux fournisseurs d\'espaces concernés, nets de la commission standard de 5 % de la plateforme et de la TVA applicable.',
    s9_4: '9.4 Remboursement pour emplacements non prouvés',
    s9_4_p1: 'Dans le cas où un Fournisseur d\'Espaces ne soumet pas de preuve valide d\'affichage pour un ou plusieurs emplacements publicitaires dans le délai requis, Scapow émettra un remboursement à l\'Annonceur comme suit :',
    s9_4_i1: "Pour chaque jour de la période de campagne durant lequel un emplacement ne diffuse pas le visuel de l'Annonceur, la valeur journalière proportionnelle de cet emplacement sera remboursée à l'Annonceur.",
    s9_4_i4: "Des frais d'annulation de 10 % seront appliqués au montant total remboursé pour les jours défaillants, plus la TVA applicable.",
    s9_4_i2: 'Les remboursements seront traités dans un délai raisonnable après confirmation que la preuve d\'affichage n\'a pas été fournie ou a été jugée invalide.',
    s9_4_i3: 'Les frais de service de la plateforme applicables aux emplacements prouvés et exécutés restent non remboursables.',
    s9_5: '9.5 Non-Exécution du Prestataire d\'Espace - Exécution Partielle de la Campagne',
    s9_5_p1: 'Si un Prestataire d\'Espace manque à son obligation d\'afficher les supports publicitaires de l\'Annonceur pendant toute la durée convenue de la campagne, chaque jour au cours duquel l\'obligation d\'affichage convenue n\'est pas respectée constitue un « Jour de Non-Exécution ».',
    s9_5_a: 'a) Responsabilité Financière envers Scapow',
    s9_5_p2: 'Pour chaque Jour de Non-Exécution, le Prestataire d\'Espace sera redevable envers la Plateforme d\'un montant équivalent au tarif de valeur publicitaire journalier applicable à l\'espace de campagne concerné (le « Montant de Non-Exécution »). Le recouvrement du Montant de Non-Exécution sera effectué à la seule discrétion de la Plateforme par l\'un ou plusieurs des moyens suivants :',
    s9_5_i1: '(i) en demandant au Prestataire d\'Espace de verser le Montant de Non-Exécution directement à la Plateforme dans le délai précisé dans un avis écrit émis par la Plateforme ; ou',
    s9_5_i2: '(ii) en déduisant le Montant de Non-Exécution de tout paiement de campagne actuel ou futur dû au Prestataire d\'Espace, que ce soit dans le cadre de la même campagne ou de tout engagement ultérieur sur la Plateforme.',
    s9_5_p3: 'La Plateforme se réserve le droit d\'appliquer les deux recours simultanément dans la mesure nécessaire pour recouvrer l\'intégralité du Montant de Non-Exécution.',
    s9_5_b: 'b) Restitution Intégrale à l\'Annonceur',
    s9_5_p4: 'Pour chaque Jour de Non-Exécution, l\'Annonceur aura droit à un remboursement intégral de tous les montants versés pour ces jours, y compris le tarif journalier de campagne correspondant, toutes les commissions applicables de la Plateforme et tous les frais de service ou de transaction attribuables à ces jours. Ce remboursement sera traité par la Plateforme dans un délai raisonnable après confirmation de la non-exécution.',
    s9_5_c: 'c) Détermination de la Non-Exécution',
    s9_5_p5: 'Le non-respect de la période d\'affichage convenue sera évalué sur la base des preuves soumises via la Plateforme, notamment les relevés de preuve d\'affichage, les rapports des Annonceurs, la documentation photographique et tout autre élément que la Plateforme jugera pertinent. La décision de la Plateforme sera définitive et contraignante aux fins du calcul du Montant de Non-Exécution et de l\'administration des remboursements aux Annonceurs, sans préjudice des droits légaux des deux parties en vertu du droit applicable.',
    s9_6: '9.6 Force Majeure - Catastrophes Naturelles',
    s9_6_p1: 'Un « Événement de Force Majeure » est une catastrophe naturelle ou une situation d\'urgence connexe, échappant au contrôle raisonnable de l\'Annonceur et du Fournisseur d\'Espaces, qui empêche matériellement un emplacement publicitaire d\'afficher le visuel de l\'Annonceur, ou rend cet affichage dangereux - notamment les séismes, inondations, tempêtes, ouragans, incendies de forêt, glissements de terrain, ordres d\'évacuation ou d\'urgence émis par les autorités compétentes, et coupures de courant causées par de tels événements. Les intempéries ordinaires, l\'usure normale et le défaut d\'entretien ne constituent pas des Événements de Force Majeure.',
    s9_6_a: 'a) Notification et Preuves',
    s9_6_p2: 'Le Fournisseur d\'Espaces doit signaler un Événement de Force Majeure via la Plateforme dans les 48 heures suivant le moment où il en a connaissance, accompagné de preuves (telles que des photographies ou des alertes officielles) et d\'une date estimée de rétablissement. La Plateforme évaluera, sur la base de ces preuves, si l\'événement est éligible ; sa décision sera définitive et contraignante aux fins de la présente section.',
    s9_6_b: 'b) Effets pour le Fournisseur d\'Espaces',
    s9_6_i1: 'Chaque jour au cours duquel l\'affichage est empêché par un Événement de Force Majeure éligible (un « Jour de Force Majeure ») ne constitue pas un Jour de Non-Conformité au sens de la section 9.5, et aucun Montant de Non-Exécution n\'est dû à ce titre.',
    s9_6_i2: 'Aucun versement n\'est dû au Fournisseur d\'Espaces pour les Jours de Force Majeure.',
    s9_6_i3: 'Le Fournisseur d\'Espaces doit rétablir l\'affichage dans un délai de 5 jours ouvrés après la fin de l\'Événement de Force Majeure. Tout jour au-delà de ce délai sans rétablissement de l\'affichage constitue un Jour de Non-Conformité au sens de la section 9.5.',
    s9_6_i4: 'Le Fournisseur d\'Espaces reste responsable de l\'entretien et de l\'assurance adéquate de ses structures, y compris du coût de réimpression et de réinstallation de tout visuel endommagé ou détruit par l\'événement.',
    s9_6_c: 'c) Effets pour l\'Annonceur',
    s9_6_i5: 'L\'Annonceur a droit au remboursement intégral de toutes les sommes payées pour les Jours de Force Majeure, y compris le tarif journalier de la campagne, la commission correspondante de la Plateforme et la TVA applicable, sans les frais de 10 % visés à la section 9.4.',
    s9_6_i6: 'L\'Annonceur peut également choisir de reporter les jours concernés à la fin de la campagne, sous réserve de la disponibilité de l\'emplacement publicitaire.',
    s9_6_i7: 'Lorsqu\'un emplacement publicitaire devient indisponible en raison d\'un Événement de Force Majeure avant le début de son activation, l\'Annonceur ou le Fournisseur d\'Espaces peut le retirer de la campagne sans frais d\'annulation, nonobstant la section 9.3, et l\'Annonceur reçoit le remboursement intégral des sommes payées à ce titre.',
    s9_6_i8: 'Lorsqu\'un Événement de Force Majeure dure plus de 14 jours, ou plus de la moitié de la période restante de la campagne sur l\'emplacement concerné, l\'Annonceur peut annuler le reste de cet emplacement sans frais et être remboursé des jours restants.',
    s9_6_i9: 'Pour les campagnes payées par mensualités, les mensualités futures sont réduites ou annulées en conséquence.',
    s9_6_d: 'd) Champ d\'application',
    s9_6_p3: 'Les événements qui n\'affectent que l\'activité propre de l\'Annonceur, et non les emplacements publicitaires, ne sont pas couverts par la présente section ; la Politique d\'Annulation des Campagnes de la section 9.3 s\'applique.',
    s9_7: '9.7 Vandalisme',
    s9_7_p1: 'Le « Vandalisme » désigne la dégradation, la défiguration ou l\'enlèvement délibérés d\'un emplacement publicitaire ou du visuel de l\'Annonceur par des tiers sans lien avec l\'Annonceur ou le Fournisseur d\'Espaces - par exemple des graffitis, des affiches arrachées ou recouvertes, ou des écrans ou structures endommagés.',
    s9_7_i1: 'Le Fournisseur d\'Espaces doit signaler le Vandalisme via la Plateforme dans les 48 heures suivant le moment où il en a connaissance, accompagné de photographies et, le cas échéant, d\'un dépôt de plainte.',
    s9_7_i2: 'Le Fournisseur d\'Espaces doit rétablir l\'affichage dans un délai de 3 jours ouvrés à compter du signalement, à ses frais, y compris la réimpression et la réinstallation du visuel.',
    s9_7_i3: 'Les jours au cours desquels l\'affichage est empêché pendant ce délai de rétablissement sont traités comme des Jours de Force Majeure au sens de la section 9.6 : l\'Annonceur a droit à leur remboursement intégral, sans frais, et aucun Montant de Non-Exécution n\'est dû.',
    s9_7_i4: 'Les jours au-delà du délai de rétablissement, ou le Vandalisme résultant de l\'absence de mesures préventives raisonnables de la part du Fournisseur d\'Espaces, constituent des Jours de Non-Conformité au sens de la section 9.5.',
    s9_7_i5: 'Lorsque le même emplacement publicitaire est vandalisé trois fois ou plus en 30 jours, le Fournisseur d\'Espaces doit prendre des mesures préventives raisonnables, et l\'Annonceur peut annuler le reste de cet emplacement sans frais et être remboursé des jours restants.',
    s9_7_p2: 'Le signalement d\'un Événement de Force Majeure ou d\'un Vandalisme qui ne s\'est pas produit est assimilé à la soumission d\'une fausse preuve d\'affichage au sens de la section 12 et peut entraîner la suspension ou la résiliation immédiate du compte.',
    proofProtectionNote: 'Votre investissement est protégé : si un emplacement extérieur ne fournit pas de preuve d\'affichage vérifiée, Scapow vous remboursera le montant correspondant pour cet emplacement.',
    s10: 'Litiges',
    s10_p1: 'Les utilisateurs s\'engagent à tenter d\'abord une résolution via la Plateforme. La Plateforme peut :',
    s10_i1: 'Examiner les preuves de campagne ;',
    s10_i2: 'Demander des documents supplémentaires ;',
    s10_i3: 'Émettre une décision non contraignante.',
    s10_p2: 'La décision de la Plateforme ne se substitue pas aux droits légaux en vertu du droit applicable.',
    s11: 'Propriété Intellectuelle',
    s11_p1: 'Les Annonceurs conservent la propriété du contenu soumis.',
    s11_p2: 'En téléchargeant des supports, les Annonceurs accordent à la Plateforme et aux Fournisseurs d\'Espaces une licence limitée et non exclusive pour utiliser, reproduire et afficher ces supports exclusivement pour l\'exécution de la campagne.',
    s11_p3: 'Les Fournisseurs d\'Espaces conservent la propriété de leurs annonces, images et données de localisation.',
    s11_p4: 'La Plateforme conserve la propriété de tous les logiciels, marques et systèmes de la plateforme.',
    s12: 'Usages Interdits',
    s12_p1: 'Les utilisateurs ne peuvent pas :',
    s12_i1: 'Commettre une fraude ;',
    s12_i2: 'Télécharger du contenu trompeur ou illégal ;',
    s12_i3: 'Contourner les paiements ;',
    s12_i4: 'Contacter des utilisateurs en dehors de la Plateforme pour éviter les frais ;',
    s12_i5: 'Manipuler les avis ou les résultats des campagnes ;',
    s12_i6: 'Télécharger une fausse preuve d\'installation.',
    s12_p2: 'Toute violation peut entraîner une suspension ou résiliation immédiate.',
    s13: 'Responsabilité',
    s13_p1: 'Dans la limite maximale permise par la loi, la Plateforme ne saurait être tenue responsable de :',
    s13_i1: 'La sous-performance d\'une campagne ;',
    s13_i2: 'Les dommages causés par les intempéries, les catastrophes naturelles et le vandalisme, régis par les sections 9.6 et 9.7 ;',
    s13_i3: 'Les retards causés par des tiers ;',
    s13_i4: 'Les défauts d\'impression non imputables à la Plateforme ;',
    s13_i5: 'Les actes ou omissions des utilisateurs.',
    s13_p2: 'La responsabilité totale ne pourra excéder le total des frais payés à la Plateforme pour la campagne concernée.',
    s14: 'Indemnisation',
    s14_p1: 'Les utilisateurs s\'engagent à indemniser et à dégager de toute responsabilité la Société contre toute réclamation, perte, dommage, responsabilité ou dépense découlant de :',
    s14_i1: 'La violation de ces Conditions ;',
    s14_i2: 'Un contenu publicitaire illégal ;',
    s14_i3: 'La violation des droits de tiers ;',
    s14_i4: 'Un comportement frauduleux.',
    s15: 'Suspension de Compte',
    s15_p1: 'La Plateforme peut suspendre ou résilier des comptes pour :',
    s15_i1: 'Fraude ;',
    s15_i2: 'Défaut de paiement ;',
    s15_i3: 'Litiges répétés ;',
    s15_i4: 'Abus de la Plateforme ;',
    s15_i5: 'Violation de ces Conditions.',
    s16: 'Fiscalité',
    s16_p1: 'Les utilisateurs sont responsables de leurs propres impôts, y compris la TVA, les taxes sur les ventes, l\'impôt sur le revenu et toute autre taxe applicable. La Plateforme peut percevoir des taxes lorsque la loi l\'exige.',
    s17: 'Protection des Données',
    s17_p1: 'Les données des utilisateurs seront traitées conformément à la Politique de Confidentialité de la Plateforme et aux lois applicables en matière de protection des données. Les utilisateurs sont responsables de s\'assurer qu\'ils disposent des droits légaux sur toutes les données personnelles téléchargées.',
    s18: 'Droit Applicable',
    s18_p1: 'Ces Conditions sont régies par les lois applicables sans égard aux principes de conflit de lois. Les litiges seront soumis à la juridiction exclusive des tribunaux compétents.',
    s19: 'Modifications',
    s19_p1: 'La Plateforme peut modifier ces Conditions à tout moment. L\'utilisation continue de la Plateforme après les modifications vaut acceptation.',
    s20: 'Contact',
    s20_p1: 'Pour toute question juridique :',
  },
  team: {
    title: "Gestion de l'Équipe",
    subtitle: "Gérez les membres de votre équipe et envoyez des invitations",
    tabUsers: 'Membres Actifs',
    tabInvitations: 'Invitations',
    noUsers: 'Aucun membre actif pour le moment',
    noUsersDesc: "Les utilisateurs apparaîtront ici une fois l'invitation acceptée",
    statusVerified: 'Vérifié',
    statusPending: 'En attente',
  },
  footer: {
    tagline:
      'Le marché qui connecte les propriétaires de publicité extérieure avec les annonceurs. Simple, efficace, percutant.',
    platform: 'Plateforme',
    browseOutdoors: 'Explorer les panneaux',
    createAccount: 'Créer un compte',
    logIn: 'Se connecter',
    forBusinesses: 'Pour les entreprises',
    registerBusiness: "Enregistrer l'entreprise",
    listOutdoors: 'Publier vos panneaux',
    runCampaigns: 'Lancer des campagnes',
    about: 'À propos',
    howItWorks: 'Comment ça marche',
    mission: 'Notre mission',
    contactUs: 'Contactez-nous',
    copyright: '© 2026 Scapow by Codify. Tous droits réservés.',
    privacy: 'Confidentialité',
    terms: 'Conditions',
  },
  language: {
    select: 'Langue',
    en: 'English',
    pt: 'Português',
    es: 'Español',
    de: 'Deutsch',
    zh: '中文',
    ja: '日本語',
    fr: 'Français',
    it: 'Italiano',
  },
  verification: {
    title: 'Vérification des panneaux de campagne',
    subtitle: 'Soumettez des photos de preuve pour vos panneaux de campagne actifs en attente de vérification. Tous les espaces d\'une campagne doivent avoir leur preuve soumise avant que le paiement de la campagne soit débloqué.',
    empty: 'Aucune vérification en attente',
    emptyDesc: "Tous vos panneaux de campagne actifs sont à jour. Revenez vérifier une fois vos campagnes lancées.",
    uploadProof: 'Téléverser une photo de preuve',
    uploaded: 'Preuve soumise',
    uploadSuccess: 'Photo de preuve soumise avec succès.',
    noName: 'Panneau de campagne',
    locating: 'Localisation…',
    awaitingVerification: 'En attente de vérification',
    verified: 'Vérifié',
    partiallyVerified: 'Partiellement vérifié',
    backToCampaigns: 'Retour aux campagnes',
    noOutdoors: 'Aucun espace trouvé pour cette campagne',
    pendingCount: '{{count}} en attente',
    notYetAvailable: 'Vérification disponible à partir du {{date}}',
    viewProof: 'Voir la photo de preuve',
    proofAlt: 'Photo de preuve',
    deleteProof: 'Supprimer la preuve',
    deleteProofSuccess: 'Photo de preuve supprimée.',
    deleteProofConfirm: 'Êtes-vous sûr de vouloir supprimer cette photo de preuve ? Cette action est irréversible.',
  },
  howItWorksPage: {
    title: 'Comment Ça Marche',
    subtitle: "Que vous possédiez des espaces publicitaires ou souhaitiez toucher de nouveaux publics, Scapow simplifie tout.",
    advertiserTab: 'Pour les Annonceurs',
    ppTab: "Pour les Propriétaires d'Espaces",
    advertiserTitle: 'Touchez Votre Audience à Grande Échelle',
    advertiserSubtitle: "Planifiez, lancez et suivez vos campagnes publicitaires extérieures - le tout sur une plateforme intuitive.",
    adStep1Title: 'Découvrez les Bons Espaces',
    adStep1Desc: "Parcourez des milliers d'emplacements extérieurs vérifiés sur une carte interactive. Filtrez par ville, format, dimensions, disponibilité et tarif journalier pour trouver les emplacements parfaits pour votre campagne.",
    adStep2Title: 'Construisez Votre Campagne',
    adStep2Desc: "Sélectionnez plusieurs panneaux et regroupez-les dans une seule campagne. Définissez vos dates, téléchargez vos créations et confirmez votre plan - sans intermédiaire.",
    adStep3Title: 'Payez en Toute Confiance',
    adStep3Desc: "Recevez une ventilation de paiement transparente avant de vous engager. Payez en toute sécurité via notre plateforme et une passerelle de paiement sécurisée, et obtenez une facture officielle - tout est documenté et traçable.",
    adStep4Title: 'Suivez Chaque Affichage',
    adStep4Desc: "Une fois votre campagne lancée, les propriétaires d'espaces soumettent une preuve photographique de l'affichage. Suivez le statut et les confirmations directement depuis votre tableau de bord.",
    ppTitle: 'Transformez Vos Espaces en Revenus',
    ppSubtitle: 'Référencez une fois, touchez des milliers d\'annonceurs et gagnez à votre rythme.',
    ppStep1Title: 'Référencez Vos Espaces',
    ppStep1Desc: "Créez des annonces détaillées pour chacun de vos emplacements extérieurs. Ajoutez dimensions, photos, tarifs et disponibilités. Plus votre annonce est complète, plus vous attirez de campagnes.",
    ppStep2Title: 'Soyez Associé à des Campagnes',
    ppStep2Desc: "Vos espaces apparaissent automatiquement dans les recherches des annonceurs. Lorsque vous êtes sélectionné pour une campagne, vous recevez une notification et une réservation confirmée - sans négociation.",
    ppStep3Title: "Téléchargez la Preuve d'Affichage",
    ppStep3Desc: "Une fois votre panneau en place, téléchargez une preuve photographique via la plateforme. C'est votre confirmation de livraison - et elle déclenche le processus de paiement.",
    ppStep4Title: 'Recevez Votre Paiement',
    ppStep4Desc: "Une fois la preuve d'affichage soumise pour chaque emplacement d'une campagne, le paiement est libéré selon les conditions convenues. Tous vos emplacements de la campagne doivent être vérifiés avant le traitement du paiement - garantissant une livraison complète avant le règlement.",
    ctaTitle: 'Prêt à commencer ?',
    ctaSubtitle: "Rejoignez des milliers d'entreprises qui grandissent déjà avec Scapow.",
    ctaAdvertiser: 'Commencer à Annoncer',
    ctaProvider: 'Référencer Mes Espaces',
  },
  brand: {
    slogan: "it's ooh good!",
  },
  missionPage: {
    title: 'Notre Mission',
    subtitle: "Connecter le marché de l'affichage extérieur - pour que chaque espace crée de l'impact et que chaque campagne trouve son public.",
    coreTitle: 'Ce Qui Nous Anime',
    coreDesc: "L'industrie de la publicité extérieure est fragmentée. De superbes espaces restent inoccupés. Les campagnes n'atteignent pas leur potentiel. Nous croyons que la technologie peut changer cela - et Scapow est notre réponse.",
    pillar1Title: "Amplifier la Portée et l'Impact",
    pillar1Desc: "Nous permettons aux annonceurs de planifier et d'exécuter des campagnes extérieures à fort impact sur plusieurs emplacements depuis une plateforme unifiée - touchant des audiences à grande échelle sans la charge opérationnelle.",
    pillar2Title: 'Maximiser les Revenus des Propriétaires',
    pillar2Desc: "Nous donnons aux propriétaires d'espaces un accès direct à un vivier qualifié de demande publicitaire, réduisant l'inventaire vacant et garantissant que leurs espaces génèrent des revenus cohérents et prévisibles.",
    pillar3Title: 'Connecter le Marché OOH Statique',
    pillar3Desc: "Nous construisons l'infrastructure dont l'industrie extérieure avait besoin depuis longtemps - un marché transparent et digital-first où l'offre rencontre la demande efficacement, équitablement et à grande échelle.",
    pillar4Title: 'La Confiance par la Transparence',
    pillar4Desc: "De la vérification des accréditations d'entreprise à la preuve photographique d'affichage, chaque étape du processus Scapow est conçue pour être vérifiable, responsable et fondée sur la confiance mutuelle entre toutes les parties.",
    visionTitle: 'Notre Vision',
    visionDesc: "Un monde où chaque espace extérieur est une opportunité - et où chaque marque peut trouver sa toile parfaite, là où son public vit, travaille et se déplace.",
    closingTitle: "Construire l'Avenir de l'OOH",
    closingDesc: "Scapow est bien plus qu'un marché. C'est le tissu connectif de l'industrie de la publicité extérieure - réunissant propriétaires d'espaces, annonceurs et la technologie qui propulse leur succès commun.",
  },
  contact: {
    label: 'Prendre Contact',
    title: 'Contactez-nous',
    subtitle: 'Une question, un retour ou simplement envie de nous saluer ? Nous serions ravis de vous entendre.',
    infoTitle: 'Parlons-en',
    infoDesc: 'Que vous soyez curieux des fonctionnalités, des tarifs ou autre chose - notre équipe est prête à répondre à toutes vos questions.',
    responseTimeTitle: 'Réponse Rapide',
    responseTimeDesc: 'Nous répondons généralement sous 24 heures.',
    emailTitle: 'Écrivez-nous',
    whatsappTitle: 'WhatsApp',
    formTitle: 'Envoyez-nous un message',
    fieldName: 'Votre Nom',
    fieldEmail: 'Votre Email',
    fieldSubject: 'Sujet',
    fieldMessage: 'Message',
    namePlaceholder: 'Jean Dupont',
    emailPlaceholder: 'vous@exemple.com',
    subjectPlaceholder: 'Comment pouvons-nous vous aider ?',
    messagePlaceholder: 'Dites-nous ce que vous avez en tête…',
    submit: 'Envoyer le message',
    submitting: 'Envoi en cours…',
    successTitle: 'Message envoyé !',
    successDesc: 'Merci de nous avoir contactés. Nous reviendrons vers vous très bientôt.',
    backHome: "Retour à l'accueil",
    errorRequired: 'Ce champ est obligatoire.',
    errorEmail: 'Veuillez saisir une adresse email valide.',
  },
  calendar: {
    calendarMonthsHint: 'Réservé par mois calendaires complets, du 1er au dernier jour. Cliquez sur un 1er pour commencer, sur un jour ultérieur pour ajouter son mois, ou dans la réservation pour la raccourcir.',
    startOnMonthFirstHint: 'Les réservations commencent le 1er d’un mois.',
    fullMonthHint: 'Réservation au mois : choisissez le jour de début, puis cliquez sur un jour ultérieur pour ajouter des mois - chacun se termine le même jour du mois suivant (en commençant un 1er, le dernier jour du mois). Cliquez dans la réservation pour la raccourcir.',
    discountsTitle: 'Réservez plus longtemps, économisez plus',
    discountTier: '{{days}} jours et +',
    discountsPickStart: 'Choisissez une date de début pour voir quelles dates de fin donnent droit à une remise.',
    discountsHighlighted: 'Plus le vert est foncé, plus la remise est importante - les étiquettes indiquent où chacune commence.',
    discountApplied: '−{{percentage}} % sur ces {{count}} jours',
    discountNextTier: 'Ajoutez {{days}} jour(s) pour économiser {{percentage}} %',
    latestStartInfo: 'Dates de début jusqu’au {{date}}',
    blockedLegend: 'Bloqué / indisponible',
    pendingLegend: 'En attente (pas encore enregistré)',
    loading: 'Chargement des disponibilités…',
    noticeRequired: 'Date de début au plus tôt : {{date}} (préavis de {{count}} jours requis)',
    minimumDaysError: 'Location minimum {{count}} jours - veuillez étendre votre sélection',
    overlapError: 'La plage sélectionnée chevauche des dates réservées - choisissez uniquement des jours consécutifs disponibles',
  },
  approvals: {
    thisBookingLegend: 'Cette réservation',
    blockedSelection: 'Période bloquée :',
    blockedSelectionEmpty: 'Choisissez les dates de début et de fin dans le calendrier.',
    title: 'Validations',
    subtitle: 'Confirmez si vos espaces sont disponibles pour ces campagnes payées.',
    emptyTitle: 'Vous êtes à jour',
    emptyDesc: 'Quand un annonceur réserve l’un de vos espaces, il apparaîtra ici pour validation.',
    campaignFallback: 'Campagne',
    outdoorsToReview: 'Espaces à examiner : {{count}}',
    startsOn: 'Début le {{date}}',
    answerBy: 'Répondre d’ici le {{date}}',
    review: 'Examiner',
    youEarn: 'Vous gagnez',
    backToList: 'Retour aux validations',
    reviewEyebrow: 'Demande de validation',
    summaryLine: 'Espaces : {{count}} · Vous gagnez {{value}}',
    deadlineNotice: 'Merci de répondre d’ici le {{date}}. Les espaces sans réponse à temps sont retirés de la campagne.',
    progress: '{{answered}} sur {{total}} répondus',
    approveAll: 'Tout valider',
    available: 'Disponible',
    unavailable: 'Indisponible',
    decisionFor: '{{name}} est-il disponible ?',
    decisionRequired: 'Veuillez choisir une réponse.',
    blockedHint: 'Indiquez quand cet espace est déjà occupé : nous bloquerons ces dates.',
    blockedFrom: 'Bloqué du',
    blockedTo: 'Bloqué jusqu’au',
    blockedRequired: 'Les deux dates sont obligatoires.',
    blockedOrder: 'La date de fin doit être égale ou postérieure à la date de début.',
    viewCreative: 'Voir le visuel de {{name}}',
    noCreative: 'Pas encore de visuel',
    feedbackMandatory: 'Une réponse est requise pour chaque espace.',
    submit: 'Envoyer les réponses',
    fixBeforeSubmit: 'Répondez pour chaque espace et vérifiez les dates bloquées.',
    confirmTitle: 'Envoyer vos réponses ?',
    confirmSummary: 'Disponibles : {{approved}} · Indisponibles : {{unavailable}}',
    confirmNote: 'Les réponses ne peuvent plus être modifiées une fois envoyées.',
    submitted: 'Merci, vos réponses ont été envoyées.',
    submitError: 'Impossible d’envoyer vos réponses.',
    allAnsweredTitle: 'Déjà répondu',
    allAnsweredDesc: 'Vous avez répondu pour tous vos espaces de cette campagne.',
    loadErrorTitle: 'Cette validation n’est pas disponible',
    loadErrorDesc: 'Elle a peut-être déjà reçu une réponse, ou la campagne a été annulée.',
  },
  status: {
    installment: {
      SCHEDULED: 'Programmée',
      PROCESSING: 'En cours',
      PAID: 'Payée',
      FAILED: 'Échouée',
      CANCELLED: 'Annulée',
    },
    campaign: {
      PENDING: 'Brouillon',
      AWAITING_PAYMENT: 'En attente de paiement',
      CONFIRMING: 'En attente des fournisseurs',
      AWAITING_CONFIRMATION: 'Décision requise',
      READY: 'Confirmée',
      RUNNING: 'En diffusion',
      COMPLETED: 'Terminée',
      CANCELLED: 'Annulée',
      UNAVAILABLE: 'Indisponible',
    },
    payment: {
      PENDING: 'Non payé',
      VALIDATING_PAYMENT: 'Validation du paiement',
      MANUAL_VALIDATION: 'En cours d’examen',
      TRANSFER_REQUESTED: 'Virement demandé',
      PAID: 'Payé',
      CANCELLED: 'Annulé',
      PARTIALLY_REFUNDED: 'Partiellement remboursé',
      FULLY_REFUNDED: 'Remboursé',
      FAILED: 'Échoué',
    },
    campaignOutdoor: {
      PENDING: 'En attente de preuve',
      VERIFYING: 'Vérification de la preuve',
      FOR_MANUAL_APPROVAL: 'Preuve en examen',
      APPROVED: 'Preuve validée',
      REJECTED: 'Preuve refusée',
      REFUNDED: 'Remboursé',
      CANCELLED: 'Annulé',
    },
    proof: {
      PENDING: 'En attente',
      VALID: 'Valide',
      MANUAL_VALIDATION: 'En cours d’examen',
      INVALID: 'Invalide',
    },
    paymentType: {
      BUYING_ADS: 'Achat publicitaire',
      SELLING_ADS: 'Versement au fournisseur',
      REFUND_BUYING_PART: 'Remboursement annonceur',
      REFUND_SELLING_PART: 'Remboursement fournisseur',
      PLACEMENT_PROVIDER_DEBT: 'Dette du fournisseur',
      PLACEMENT_PROVIDER_CANCELLATION_FEE: 'Compensation d’annulation',
    },
  },
  offlineCampaigns: {
    creativesTitle: 'Visuels',
    creativesSubtitle: 'Visuels à installer. Toutes les dimensions sont acceptées - vous décidez comment ils s’adaptent à chaque espace.',
    uploadCreatives: 'Importer des visuels',
    noCreatives: 'Aucun visuel pour l’instant. Cliquez pour importer des fichiers JPG, PNG, TIFF ou PDF.',
    creativesUploaded: 'Visuels importés.',
    creativeRemoved: 'Visuel supprimé.',
    removeCreative: 'Supprimer le visuel',
    removeCreativeConfirm: 'Supprimer ce visuel ? Cette action est irréversible.',
    downloadOriginal: 'Télécharger l’original',
    filesTitle: 'Fichiers',
    filesSubtitle: 'Contrats, briefs ou tout autre fichier de cette campagne.',
    uploadFiles: 'Importer des fichiers',
    noFiles: 'Aucun fichier importé pour l’instant.',
    filesUploaded: 'Fichiers importés.',
    fileRemoved: 'Fichier supprimé.',
    removeFile: 'Supprimer le fichier',
    removeFileConfirm: 'Supprimer « {{name}} » ? Cette action est irréversible.',
    download: 'Télécharger',
    remove: 'Supprimer',
    outdoorsTitle: 'Espaces',
    noOutdoors: 'Cette campagne n’a pas encore d’espace.',
    modalTitle: 'Ajouter à une campagne hors ligne',
    newTitle: 'Nouvelle campagne hors ligne',
    pickTitle: 'Choisir une campagne hors ligne',
    datesTitle: 'Choisissez les dates',
    doneTitle: 'Espace ajouté',
    forOutdoor: 'Espace :',
    optionNew: 'Nouvelle',
    optionNewDesc: 'Créez une campagne pour une réservation vendue en dehors de Scapow.',
    optionPick: 'Choisir une existante',
    optionPickDesc: 'Ajoutez-le à l’une de vos campagnes hors ligne.',
    name: 'Nom de la campagne',
    nameRequired: 'Donnez un nom à la campagne.',
    details: 'Détails',
    detailsHint: 'Par ex. le client ou le canal de vente.',
    notes: 'Notes',
    notesHint: 'Notes internes - visibles uniquement par votre équipe.',
    instructions: 'Instructions',
    instructionsHint: 'Pour la personne qui installe le visuel.',
    createAndContinue: 'Créer et continuer',
    createError: 'Impossible de créer la campagne hors ligne.',
    addError: 'Impossible d’ajouter l’espace à la campagne.',
    noneYet: 'Vous n’avez pas encore de campagne hors ligne.',
    outdoorsCount: 'Espaces : {{count}}',
    createdOn: 'créée le {{date}}',
    datesIntro: 'Choisissez quand l’espace est réservé pour « {{campaign}} ». Les dates déjà prises sont affichées et ne peuvent pas être sélectionnées.',
    pickDates: 'Choisissez les dates de début et de fin dans le calendrier.',
    addToCampaign: 'Ajouter à la campagne',
    doneMessage: '{{outdoor}} a été ajouté à « {{campaign}} ».',
    doneHint: 'Ces dates sont désormais bloquées pour les autres réservations.',
    backToSearch: 'Retour à la recherche',
    getAvailability: 'Voir les disponibilités',
    clearAvailability: 'Effacer les disponibilités',
    availabilityTitle: 'Voir les disponibilités',
    availabilityHint: 'Choisissez une date de début et de fin pour n’afficher que les espaces libres sur toute la période.',
    showAvailable: 'Afficher les espaces disponibles',
    dimensionsLabel: 'Dimensions',
    noMatches: 'Aucun espace ne correspond à ces filtres',
    noMatchesHint: 'Essayez d’autres dimensions ou dates, ou effacez les filtres.',
    clearFilters: 'Effacer les filtres',
    addButton: 'Ajouter à une campagne hors ligne',
    addTooltip: 'Ajouter à une campagne non réservée via Scapow',
  },
};

export default fr;
